import { SVGProps } from 'react';
import styles from './styles.module.css';

type IconBaseProps = SVGProps<SVGSVGElement>;
type PreIconProps = Omit<IconBaseProps, 'children'>;
interface IconProps extends PreIconProps {
  isActive?: boolean;
}

const IconBase = ({
  children,
  className = '',
  width = 24,
  height = 24,
  ...props
}: IconBaseProps) => (
  <svg
    style={{ width, height }}
    className={`${styles.icon} ${className}`}
    viewBox={`0 0 ${width} ${height}`}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {children}
  </svg>
);

export const AgroCultIcon = (props: IconProps) => {
  return !props.isActive ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#EEF2FD" />
      <path
        d="M34.9201 30.6064H29.4844V29.0636H34.8844C35.3415 29.0636 35.7106 28.9922 35.9915 28.8493C36.2725 28.7017 36.4772 28.4993 36.6058 28.2422C36.7344 27.9803 36.7987 27.6803 36.7987 27.3422C36.7987 27.0279 36.732 26.735 36.5987 26.4636C36.4653 26.1922 36.2606 25.9731 35.9844 25.8064C35.7129 25.6398 35.3606 25.5564 34.9272 25.5564H32.8987V34.3993H30.9344V23.9993H34.9201C35.7344 23.9993 36.4272 24.1422 36.9987 24.4279C37.5701 24.7136 38.0082 25.1064 38.3129 25.6064C38.6225 26.1064 38.7772 26.6803 38.7772 27.3279C38.7772 28.0136 38.6201 28.6017 38.3058 29.0922C37.9963 29.5826 37.5534 29.9588 36.9772 30.2207C36.4058 30.4779 35.7201 30.6064 34.9201 30.6064ZM35.2058 31.2779V32.8279H29.4844V31.2779H35.2058Z"
        fill="#C9D5F2"
      />
      <path
        d="M11.0076 28.7645L8.28384 31.4882C7.90539 31.8667 7.90539 32.4803 8.28384 32.8587C8.66229 33.2371 9.27584 33.2371 9.65424 32.8587L12.378 30.1349C11.7524 29.8855 11.2569 29.39 11.0076 28.7645Z"
        fill="#C9D5F2"
      />
      <path
        d="M32.7265 8.64241L32.7021 8.44034L32.5 8.41589C30.8717 8.21875 28.9824 8.9742 27.5692 10.3874C26.1562 11.8006 25.4007 13.6899 25.5978 15.3182L25.6222 15.5203L25.8243 15.5447C25.9955 15.5654 26.1696 15.5756 26.3458 15.5756C27.8446 15.5756 29.4905 14.8377 30.7551 13.5732C32.1682 12.16 32.9236 10.2706 32.7265 8.64241Z"
        fill="#C9D5F2"
      />
      <path
        d="M25.8038 6.8586C25.4966 6.55141 24.9987 6.55141 24.6915 6.8586L22.3409 9.20925C21.1135 10.114 20.228 11.7331 19.9934 13.5449C19.7369 15.5269 20.292 17.4845 21.4422 18.6538L21.5849 18.799L21.7599 18.695C23.1698 17.857 24.205 16.1052 24.4615 14.1233C24.6544 12.6332 24.3884 11.1569 23.7557 10.0189L25.8038 7.97085C26.1109 7.66371 26.1109 7.16574 25.8038 6.8586Z"
        fill="#C9D5F2"
      />
      <path
        d="M13.5308 18.4964L13.3881 18.3513L13.2131 18.4553C11.8032 19.2933 10.7679 21.045 10.5114 23.027C10.2549 25.009 10.81 26.9665 11.9602 28.1359L12.1029 28.281L12.2779 28.177C13.6878 27.339 14.723 25.5872 14.9795 23.6053C15.2361 21.6233 14.681 19.6657 13.5308 18.4964Z"
        fill="#C9D5F2"
      />
      <path
        d="M18.2722 13.7551L18.1294 13.61L17.9545 13.714C16.5445 14.5519 15.5093 16.3037 15.2527 18.2857C14.9962 20.2677 15.5513 22.2253 16.7015 23.3945L16.8442 23.5396L17.0192 23.4356C18.4291 22.5976 19.4644 20.8459 19.7209 18.864C19.9774 16.882 19.4223 14.9244 18.2722 13.7551Z"
        fill="#C9D5F2"
      />
      <path
        d="M22.6461 27.6116C21.4768 26.4615 19.5191 25.9064 17.5373 26.1629C15.5553 26.4195 13.8035 27.4547 12.9656 28.8646L12.8616 29.0396L13.0067 29.1823C13.9872 30.1467 15.5219 30.6928 17.1604 30.6928C17.476 30.6928 17.7955 30.6725 18.1156 30.631C20.0976 30.3745 21.8493 29.3393 22.6873 27.9293L22.7912 27.7543L22.6461 27.6116Z"
        fill="#C9D5F2"
      />
      <path
        d="M27.3875 22.8703C26.2182 21.7202 24.2603 21.165 22.2786 21.4216C20.2967 21.6781 18.5449 22.7134 17.7069 24.1233L17.6029 24.2983L17.748 24.441C18.7285 25.4054 20.2632 25.9514 21.9018 25.9514C22.2174 25.9514 22.5369 25.9312 22.8569 25.8898C24.8389 25.6332 26.5907 24.598 27.4286 23.1881L27.5326 23.0131L27.3875 22.8703Z"
        fill="#C9D5F2"
      />
      <path
        d="M34.2839 15.3387C33.9768 15.0316 33.4788 15.0316 33.1717 15.3387L31.1236 17.3868C29.9856 16.7541 28.5092 16.488 27.0192 16.6809C25.0373 16.9375 23.2855 17.9727 22.4475 19.3826L22.3436 19.5576L22.4887 19.7003C23.4691 20.6647 25.0038 21.2108 26.6424 21.2108C26.958 21.2108 27.2775 21.1905 27.5975 21.1491C29.4095 20.9146 31.0285 20.029 31.9333 18.8015L34.2839 16.451C34.5911 16.1439 34.5911 15.6459 34.2839 15.3387Z"
        fill="#C9D5F2"
      />
      <path
        d="M13.4844 37.7139C12.9794 37.7139 12.5701 38.1233 12.5701 38.6282C12.5701 39.1332 12.9794 39.5425 13.4844 39.5425L13.4844 37.7139ZM13.4844 39.5425L36.3415 39.5425L36.3415 37.7139L13.4844 37.7139L13.4844 39.5425Z"
        fill="#C9D5F2"
      />
      <path d="M40 38.6289L35.2 41.0043L35.2 36.2535L40 38.6289Z" fill="#C9D5F2" />
    </svg>
  ) : (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#E1F3EA" />
      <path
        d="M34.9201 30.6064H29.4844V29.0636H34.8844C35.3415 29.0636 35.7106 28.9922 35.9915 28.8493C36.2725 28.7017 36.4772 28.4993 36.6058 28.2422C36.7344 27.9803 36.7987 27.6803 36.7987 27.3422C36.7987 27.0279 36.732 26.735 36.5987 26.4636C36.4653 26.1922 36.2606 25.9731 35.9844 25.8064C35.7129 25.6398 35.3606 25.5564 34.9272 25.5564H32.8987V34.3993H30.9344V23.9993H34.9201C35.7344 23.9993 36.4272 24.1422 36.9987 24.4279C37.5701 24.7136 38.0082 25.1064 38.3129 25.6064C38.6225 26.1064 38.7772 26.6803 38.7772 27.3279C38.7772 28.0136 38.6201 28.6017 38.3058 29.0922C37.9963 29.5826 37.5534 29.9588 36.9772 30.2207C36.4058 30.4779 35.7201 30.6064 34.9201 30.6064ZM35.2058 31.2779V32.8279H29.4844V31.2779H35.2058Z"
        fill="#66B28A"
      />
      <path
        d="M11.0076 28.7645L8.28384 31.4882C7.90539 31.8667 7.90539 32.4803 8.28384 32.8587C8.66229 33.2371 9.27584 33.2371 9.65424 32.8587L12.378 30.1349C11.7524 29.8855 11.2569 29.39 11.0076 28.7645Z"
        fill="#66B28A"
      />
      <path
        d="M32.7265 8.64241L32.7021 8.44034L32.5 8.41589C30.8717 8.21875 28.9824 8.9742 27.5692 10.3874C26.1562 11.8006 25.4007 13.6899 25.5978 15.3182L25.6222 15.5203L25.8243 15.5447C25.9955 15.5654 26.1696 15.5756 26.3458 15.5756C27.8446 15.5756 29.4905 14.8377 30.7551 13.5732C32.1682 12.16 32.9236 10.2706 32.7265 8.64241Z"
        fill="#66B28A"
      />
      <path
        d="M25.8038 6.8586C25.4966 6.55141 24.9987 6.55141 24.6915 6.8586L22.3409 9.20925C21.1135 10.114 20.228 11.7331 19.9934 13.5449C19.7369 15.5269 20.292 17.4845 21.4422 18.6538L21.5849 18.799L21.7599 18.695C23.1698 17.857 24.205 16.1052 24.4615 14.1233C24.6544 12.6332 24.3884 11.1569 23.7557 10.0189L25.8038 7.97085C26.1109 7.66371 26.1109 7.16574 25.8038 6.8586Z"
        fill="#66B28A"
      />
      <path
        d="M13.5308 18.4964L13.3881 18.3513L13.2131 18.4553C11.8032 19.2933 10.7679 21.045 10.5114 23.027C10.2549 25.009 10.81 26.9665 11.9602 28.1359L12.1029 28.281L12.2779 28.177C13.6878 27.339 14.723 25.5872 14.9795 23.6053C15.2361 21.6233 14.681 19.6657 13.5308 18.4964Z"
        fill="#66B28A"
      />
      <path
        d="M18.2722 13.7551L18.1294 13.61L17.9545 13.714C16.5445 14.5519 15.5093 16.3037 15.2527 18.2857C14.9962 20.2677 15.5513 22.2253 16.7015 23.3945L16.8442 23.5396L17.0192 23.4356C18.4291 22.5976 19.4644 20.8459 19.7209 18.864C19.9774 16.882 19.4223 14.9244 18.2722 13.7551Z"
        fill="#66B28A"
      />
      <path
        d="M22.6461 27.6116C21.4768 26.4615 19.5191 25.9064 17.5373 26.1629C15.5553 26.4195 13.8035 27.4547 12.9656 28.8646L12.8616 29.0396L13.0067 29.1823C13.9872 30.1467 15.5219 30.6928 17.1604 30.6928C17.476 30.6928 17.7955 30.6725 18.1156 30.631C20.0976 30.3745 21.8493 29.3393 22.6873 27.9293L22.7912 27.7543L22.6461 27.6116Z"
        fill="#66B28A"
      />
      <path
        d="M27.3875 22.8703C26.2182 21.7202 24.2603 21.165 22.2786 21.4216C20.2967 21.6781 18.5449 22.7134 17.7069 24.1233L17.6029 24.2983L17.748 24.441C18.7285 25.4054 20.2632 25.9514 21.9018 25.9514C22.2174 25.9514 22.5369 25.9312 22.8569 25.8898C24.8389 25.6332 26.5907 24.598 27.4286 23.1881L27.5326 23.0131L27.3875 22.8703Z"
        fill="#66B28A"
      />
      <path
        d="M34.2839 15.3387C33.9768 15.0316 33.4788 15.0316 33.1717 15.3387L31.1236 17.3868C29.9856 16.7541 28.5092 16.488 27.0192 16.6809C25.0373 16.9375 23.2855 17.9727 22.4475 19.3826L22.3436 19.5576L22.4887 19.7003C23.4691 20.6647 25.0038 21.2108 26.6424 21.2108C26.958 21.2108 27.2775 21.1905 27.5975 21.1491C29.4095 20.9146 31.0285 20.029 31.9333 18.8015L34.2839 16.451C34.5911 16.1439 34.5911 15.6459 34.2839 15.3387Z"
        fill="#66B28A"
      />
      <path
        d="M13.4844 37.7139C12.9794 37.7139 12.5701 38.1233 12.5701 38.6282C12.5701 39.1332 12.9794 39.5425 13.4844 39.5425L13.4844 37.7139ZM13.4844 39.5425L36.3415 39.5425L36.3415 37.7139L13.4844 37.7139L13.4844 39.5425Z"
        fill="#66B28A"
      />
      <path d="M40 38.6289L35.2 41.0043L35.2 36.2535L40 38.6289Z" fill="#66B28A" />
    </svg>
  );
};

export const SearchIcon = (props: IconProps) => {
  return !props.isActive ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#EEF2FD" />
      <g clip-path="url(#clip0_6199_1963)">
        <path
          d="M34.5592 30.0824C39.1471 25.4943 39.147 18.029 34.5592 13.4409C29.9711 8.8529 22.5059 8.8529 17.9179 13.4409C14.0256 17.3333 13.4361 23.1221 16.1479 27.6426C16.1479 27.6426 16.3427 27.9694 16.0796 28.2323L10.076 34.2359C8.88107 35.4307 8.5966 37.1016 9.65628 38.1615L9.83873 38.3437C10.8984 39.4036 12.5694 39.1192 13.7642 37.9243L19.7552 31.9333C20.0309 31.6576 20.3576 31.8524 20.3576 31.8524C24.878 34.5641 30.6668 33.9747 34.5592 30.0824ZM20.0904 27.9098C16.7003 24.5197 16.7004 19.0037 20.0905 15.6136C23.4806 12.2237 28.9966 12.2236 32.3866 15.6136C35.7766 19.0036 35.7766 24.5197 32.3866 27.9098C28.9965 31.2997 23.4806 31.2997 20.0904 27.9098Z"
          fill="#C9D5F2"
        />
        <path
          d="M20.8412 21.0634C20.6834 21.0634 20.523 21.0324 20.3684 20.9671C19.7508 20.7057 19.4618 19.9931 19.7232 19.3753C21.3661 15.4928 25.8613 13.6708 29.7437 15.3137C30.3614 15.5751 30.6503 16.2878 30.3889 16.9055C30.1274 17.5232 29.415 17.8119 28.7971 17.5506C26.1482 16.4298 23.081 17.6729 21.9602 20.3218C21.7641 20.7851 21.3144 21.0634 20.8412 21.0634Z"
          fill="#C9D5F2"
        />
      </g>
      <defs>
        <clipPath id="clip0_6199_1963">
          <rect width="29" height="29" fill="white" transform="translate(9 10)" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#E1F3EA" />
      <g clip-path="url(#clip0_6199_1963)">
        <path
          d="M34.5592 30.0824C39.1471 25.4943 39.147 18.029 34.5592 13.4409C29.9711 8.8529 22.5059 8.8529 17.9179 13.4409C14.0256 17.3333 13.4361 23.1221 16.1479 27.6426C16.1479 27.6426 16.3427 27.9694 16.0796 28.2323L10.076 34.2359C8.88107 35.4307 8.5966 37.1016 9.65628 38.1615L9.83873 38.3437C10.8984 39.4036 12.5694 39.1192 13.7642 37.9243L19.7552 31.9333C20.0309 31.6576 20.3576 31.8524 20.3576 31.8524C24.878 34.5641 30.6668 33.9747 34.5592 30.0824ZM20.0904 27.9098C16.7003 24.5197 16.7004 19.0037 20.0905 15.6136C23.4806 12.2237 28.9966 12.2236 32.3866 15.6136C35.7766 19.0036 35.7766 24.5197 32.3866 27.9098C28.9965 31.2997 23.4806 31.2997 20.0904 27.9098Z"
          fill="#66B28A"
        />
        <path
          d="M20.8412 21.0634C20.6834 21.0634 20.523 21.0324 20.3684 20.9671C19.7508 20.7057 19.4618 19.9931 19.7232 19.3753C21.3661 15.4928 25.8613 13.6708 29.7437 15.3137C30.3614 15.5751 30.6503 16.2878 30.3889 16.9055C30.1274 17.5232 29.415 17.8119 28.7971 17.5506C26.1482 16.4298 23.081 17.6729 21.9602 20.3218C21.7641 20.7851 21.3144 21.0634 20.8412 21.0634Z"
          fill="#66B28A"
        />
      </g>
      <defs>
        <clipPath id="clip0_6199_1963">
          <rect width="29" height="29" fill="white" transform="translate(9 10)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WarehouseStationary = (props: IconProps) => (
  <IconBase width={34} height={34} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.871795 8.13718C0.343879 8.35714 0 8.87296 0 9.44487V28.3338H4.25V12.7504C4.25 11.968 4.88427 11.3338 5.66667 11.3338H28.3333C29.1158 11.3338 29.75 11.968 29.75 12.7504V28.3338H34V9.44487C34 8.87296 33.6562 8.35714 33.1282 8.13718L17.5448 1.64413C17.1962 1.49883 16.8038 1.49883 16.4552 1.64413L0.871795 8.13718Z"
      fill={props.fill}
    />
    <path
      d="M25.4999 22.667H8.49992C7.71752 22.667 7.08325 23.3013 7.08325 24.0837V26.917C7.08325 27.6994 7.71752 28.3337 8.49992 28.3337H25.4999C26.2823 28.3337 26.9166 27.6994 26.9166 26.917V24.0837C26.9166 23.3013 26.2823 22.667 25.4999 22.667Z"
      fill={props.fill}
    />
    <path
      d="M25.4999 14.167H8.49992C7.71752 14.167 7.08325 14.8013 7.08325 15.5837V18.417C7.08325 19.1994 7.71752 19.8337 8.49992 19.8337H25.4999C26.2823 19.8337 26.9166 19.1994 26.9166 18.417V15.5837C26.9166 14.8013 26.2823 14.167 25.4999 14.167Z"
      fill={props.fill}
    />
  </IconBase>
);

/* Иконки для сайд-меню */

export const MixingMenu = (props: IconProps) => (
  <IconBase width={26} height={27} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0H5.77798V6.435L15.8894 12.645V24H10.1115V16.065L0 9.855V0Z"
      fill={props.fill ?? '#DFE6FA'}
    />
    <path
      d="M21.6674 19.5L13.0005 27L4.3335 19.5H21.6674Z"
      fill={props.fill ?? '#DFE6FA'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.222 0V6.435L14.2418 10.11L17.1597 11.895V15.285L26 9.855V0H20.222Z"
      fill={props.fill ?? '#DFE6FA'}
    />
  </IconBase>
);

export const PricesMenu = (props: IconProps) => (
  <IconBase width={30} height={30} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.947735 14.8421L15.7898 0H26.8425C28.5793 0 30.0004 1.42105 30.0004 3.15789V14.2105L15.1583 29.0526C13.8951 30.3158 11.9214 30.3158 10.6583 29.0526L0.947735 19.3421C-0.315423 18.0789 -0.315423 16.1053 0.947735 14.8421ZM23.6846 4.73684C23.6846 5.60526 24.3951 6.31579 25.2635 6.31579C26.1319 6.31579 26.8425 5.60526 26.8425 4.73684C26.8425 3.86842 26.1319 3.15789 25.2635 3.15789C24.3951 3.15789 23.6846 3.86842 23.6846 4.73684Z"
      fill={props.fill ?? '#DFE6FA'}
    />
    <path
      d="M14.9356 16.9721L9.84343 11.88L11.2888 10.4346L16.3475 15.4933C16.7757 15.9216 17.1883 16.2004 17.5854 16.3297C17.9868 16.4546 18.3683 16.4569 18.7296 16.3364C19.0954 16.2115 19.4366 15.9907 19.7534 15.674C20.0478 15.3796 20.2597 15.0428 20.389 14.6636C20.5184 14.2844 20.5318 13.8874 20.4292 13.4725C20.3311 13.0621 20.079 12.6539 19.6731 12.248L17.7727 10.3476L9.48878 18.6316L7.64865 16.7914L17.3913 7.04878L21.1251 10.7826C21.8879 11.5454 22.4032 12.3283 22.6708 13.1312C22.9385 13.9342 22.9808 14.7126 22.7979 15.4665C22.6195 16.2249 22.2269 16.9074 21.6203 17.5141C20.9779 18.1565 20.2798 18.5602 19.5259 18.7252C18.7764 18.8948 18.0091 18.8323 17.224 18.5379C16.4478 18.2435 15.685 17.7215 14.9356 16.9721ZM14.5742 17.8687L13.1222 19.3208L7.76241 13.961L9.21444 12.509L14.5742 17.8687Z"
      fill="#EEF2FD"
    />
  </IconBase>
);

export const CalcIcon = (props: IconProps) => {
  return props.isActive ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#E1F3EA" />
      <g clip-path="url(#clip0_5937_115953)">
        <path
          d="M23.7636 10H12.5488C11.1434 10 10 11.1434 10 12.5489V23.7637H23.7636V10Z"
          fill="#66B28A"
          stroke="#E1F3EA"
          stroke-width="1.03571"
        />
        <path
          d="M37.5273 23.7637V12.5489C37.5273 11.1434 36.3839 10 34.9785 10H23.7637V23.7637H37.5273Z"
          fill="#66B28A"
          stroke="#E1F3EA"
          stroke-width="1.03571"
        />
        <path
          d="M23.7637 23.7637V37.5273H29.3144C29.5398 37.5273 29.7559 37.4378 29.9152 37.2785L37.2784 29.9152C37.3573 29.8363 37.4199 29.7427 37.4626 29.6396C37.5053 29.5365 37.5273 29.426 37.5273 29.3145V23.7637H23.7637Z"
          fill="#66B28A"
        />
        <path
          d="M36.6777 29.3145H36.6783M23.7637 23.7637V37.5273H29.3144C29.5398 37.5273 29.7559 37.4378 29.9152 37.2785L37.2784 29.9152C37.3573 29.8363 37.4199 29.7427 37.4626 29.6396C37.5053 29.5365 37.5273 29.426 37.5273 29.3145V23.7637H23.7637Z"
          stroke="#E1F3EA"
          stroke-width="1.03571"
        />
        <path
          d="M10 23.7637V34.9785C10 36.3839 11.1434 37.5273 12.5488 37.5273H23.7636V23.7637H10Z"
          fill="#66B28A"
          stroke="#E1F3EA"
          stroke-width="1.03571"
        />
        <path
          d="M18.8642 16.0322H17.7314V14.8994C17.7314 14.4302 17.351 14.0498 16.8818 14.0498C16.4126 14.0498 16.0322 14.4302 16.0322 14.8994V16.0322H14.8994C14.4302 16.0322 14.0498 16.4126 14.0498 16.8818C14.0498 17.3511 14.4302 17.7315 14.8994 17.7315H16.0322V18.8643C16.0322 19.3335 16.4126 19.7139 16.8818 19.7139C17.351 19.7139 17.7314 19.3335 17.7314 18.8643V17.7315H18.8642C19.3335 17.7315 19.7139 17.3511 19.7139 16.8818C19.7139 16.4126 19.3335 16.0322 18.8642 16.0322Z"
          fill="#E1F3EA"
        />
        <path
          d="M32.6279 17.7314H28.6631C28.1939 17.7314 27.8135 17.351 27.8135 16.8818C27.8135 16.4126 28.1939 16.0322 28.6631 16.0322H32.6279C33.0971 16.0322 33.4775 16.4126 33.4775 16.8818C33.4775 17.351 33.0971 17.7314 32.6279 17.7314Z"
          fill="#E1F3EA"
        />
        <path
          d="M18.0834 30.6455L18.8986 29.8302C19.2304 29.4985 19.2304 28.9605 18.8986 28.6288C18.5668 28.2969 18.0289 28.2969 17.6971 28.6288L16.8818 29.444L16.0666 28.6288C15.7348 28.2969 15.1968 28.2969 14.8651 28.6288C14.5332 28.9605 14.5332 29.4985 14.8651 29.8302L15.6803 30.6455L14.8651 31.4608C14.5332 31.7925 14.5332 32.3305 14.8651 32.6623C14.9439 32.7413 15.0375 32.804 15.1406 32.8467C15.2437 32.8894 15.3542 32.9113 15.4658 32.9111C15.5774 32.9113 15.688 32.8894 15.7911 32.8467C15.8942 32.804 15.9878 32.7413 16.0666 32.6623L16.8818 31.847L17.6971 32.6623C17.7759 32.7413 17.8695 32.804 17.9726 32.8467C18.0757 32.8894 18.1863 32.9113 18.2979 32.9111C18.4095 32.9113 18.52 32.8894 18.6231 32.8467C18.7262 32.804 18.8198 32.7413 18.8986 32.6623C19.2304 32.3305 19.2304 31.7925 18.8986 31.4608L18.0834 30.6455Z"
          fill="#E1F3EA"
        />
        <path
          d="M21.9593 30.2207C21.9593 34.7756 25.6657 38.4821 30.2207 38.4821C34.7756 38.4821 38.4821 34.7756 38.4821 30.2207C38.4821 25.6658 34.7756 21.9593 30.2207 21.9593C25.6657 21.9593 21.9593 25.6658 21.9593 30.2207Z"
          fill="#66B28A"
          stroke="#E1F3EA"
          stroke-width="1.03571"
        />
        <path
          d="M32.2031 32.7695H28.2383C27.7691 32.7695 27.3887 32.3891 27.3887 31.9199C27.3887 31.4507 27.7691 31.0703 28.2383 31.0703H32.2031C32.6723 31.0703 33.0527 31.4507 33.0527 31.9199C33.0527 32.3891 32.6723 32.7695 32.2031 32.7695Z"
          fill="#E1F3EA"
        />
        <path
          d="M32.2031 29.3711H28.2383C27.7691 29.3711 27.3887 28.9907 27.3887 28.5215C27.3887 28.0523 27.7691 27.6719 28.2383 27.6719H32.2031C32.6723 27.6719 33.0527 28.0523 33.0527 28.5215C33.0527 28.9907 32.6723 29.3711 32.2031 29.3711Z"
          fill="#E1F3EA"
        />
      </g>
      <defs>
        <clipPath id="clip0_5937_115953">
          <rect width="29" height="29" fill="white" transform="translate(10 10)" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#EEF2FD" />
      <g clip-path="url(#clip0_5937_115952)">
        <path
          d="M23.7636 10H12.5488C11.1434 10 10 11.1434 10 12.5489V23.7637H23.7636V10Z"
          fill="#C9D5F2"
          stroke="#EEF2FD"
          stroke-width="1.03571"
        />
        <path
          d="M37.5273 23.7637V12.5489C37.5273 11.1434 36.3839 10 34.9785 10H23.7637V23.7637H37.5273Z"
          fill="#C9D5F2"
          stroke="#EEF2FD"
          stroke-width="1.03571"
        />
        <path
          d="M23.7637 23.7637V37.5273H29.3144C29.5398 37.5273 29.7559 37.4378 29.9152 37.2785L37.2784 29.9152C37.3573 29.8363 37.4199 29.7427 37.4626 29.6396C37.5053 29.5365 37.5273 29.426 37.5273 29.3145V23.7637H23.7637Z"
          fill="#C9D5F2"
        />
        <path
          d="M36.6777 29.3145H36.6783M23.7637 23.7637V37.5273H29.3144C29.5398 37.5273 29.7559 37.4378 29.9152 37.2785L37.2784 29.9152C37.3573 29.8363 37.4199 29.7427 37.4626 29.6396C37.5053 29.5365 37.5273 29.426 37.5273 29.3145V23.7637H23.7637Z"
          stroke="#EEF2FD"
          stroke-width="1.03571"
        />
        <path
          d="M10 23.7637V34.9785C10 36.3839 11.1434 37.5273 12.5488 37.5273H23.7636V23.7637H10Z"
          fill="#C9D5F2"
          stroke="#EEF2FD"
          stroke-width="1.03571"
        />
        <path
          d="M18.8642 16.0322H17.7314V14.8994C17.7314 14.4302 17.351 14.0498 16.8818 14.0498C16.4126 14.0498 16.0322 14.4302 16.0322 14.8994V16.0322H14.8994C14.4302 16.0322 14.0498 16.4126 14.0498 16.8818C14.0498 17.3511 14.4302 17.7315 14.8994 17.7315H16.0322V18.8643C16.0322 19.3335 16.4126 19.7139 16.8818 19.7139C17.351 19.7139 17.7314 19.3335 17.7314 18.8643V17.7315H18.8642C19.3335 17.7315 19.7139 17.3511 19.7139 16.8818C19.7139 16.4126 19.3335 16.0322 18.8642 16.0322Z"
          fill="#EEF2FD"
        />
        <path
          d="M32.6279 17.7314H28.6631C28.1939 17.7314 27.8135 17.351 27.8135 16.8818C27.8135 16.4126 28.1939 16.0322 28.6631 16.0322H32.6279C33.0971 16.0322 33.4775 16.4126 33.4775 16.8818C33.4775 17.351 33.0971 17.7314 32.6279 17.7314Z"
          fill="#EEF2FD"
        />
        <path
          d="M18.0834 30.6455L18.8986 29.8302C19.2304 29.4985 19.2304 28.9605 18.8986 28.6288C18.5668 28.2969 18.0289 28.2969 17.6971 28.6288L16.8818 29.444L16.0666 28.6288C15.7348 28.2969 15.1968 28.2969 14.8651 28.6288C14.5332 28.9605 14.5332 29.4985 14.8651 29.8302L15.6803 30.6455L14.8651 31.4608C14.5332 31.7925 14.5332 32.3305 14.8651 32.6623C14.9439 32.7413 15.0375 32.804 15.1406 32.8467C15.2437 32.8894 15.3542 32.9113 15.4658 32.9111C15.5774 32.9113 15.688 32.8894 15.7911 32.8467C15.8942 32.804 15.9878 32.7413 16.0666 32.6623L16.8818 31.847L17.6971 32.6623C17.7759 32.7413 17.8695 32.804 17.9726 32.8467C18.0757 32.8894 18.1863 32.9113 18.2979 32.9111C18.4095 32.9113 18.52 32.8894 18.6231 32.8467C18.7262 32.804 18.8198 32.7413 18.8986 32.6623C19.2304 32.3305 19.2304 31.7925 18.8986 31.4608L18.0834 30.6455Z"
          fill="#EEF2FD"
        />
        <path
          d="M21.9593 30.2207C21.9593 34.7756 25.6657 38.4821 30.2207 38.4821C34.7756 38.4821 38.4821 34.7756 38.4821 30.2207C38.4821 25.6658 34.7756 21.9593 30.2207 21.9593C25.6657 21.9593 21.9593 25.6658 21.9593 30.2207Z"
          fill="#C9D5F2"
          stroke="#EEF2FD"
          stroke-width="1.03571"
        />
        <path
          d="M32.2031 32.7695H28.2383C27.7691 32.7695 27.3887 32.3891 27.3887 31.9199C27.3887 31.4507 27.7691 31.0703 28.2383 31.0703H32.2031C32.6723 31.0703 33.0527 31.4507 33.0527 31.9199C33.0527 32.3891 32.6723 32.7695 32.2031 32.7695Z"
          fill="#EEF2FD"
        />
        <path
          d="M32.2031 29.3711H28.2383C27.7691 29.3711 27.3887 28.9907 27.3887 28.5215C27.3887 28.0523 27.7691 27.6719 28.2383 27.6719H32.2031C32.6723 27.6719 33.0527 28.0523 33.0527 28.5215C33.0527 28.9907 32.6723 29.3711 32.2031 29.3711Z"
          fill="#EEF2FD"
        />
      </g>
      <defs>
        <clipPath id="clip0_5937_115952">
          <rect width="29" height="29" fill="white" transform="translate(10 10)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CalcIconActive = (props: IconProps) => (
  <IconBase width={48} height={48} viewBox="0 0 48 48" fill="none" {...props}>
    <g clipPath="url(#clip0_3128_3726)">
      <path
        d="M12.3398 3.71933e-05H2.28515C1.02512 3.71933e-05 0 1.02516 0 2.28519V12.3398H12.3398V3.71933e-05Z"
        fill="#66B28A"
        stroke="#E1F3EA"
        strokeWidth="0.999997"
      />
      <path
        d="M24.6797 12.3398V2.28519C24.6797 1.02516 23.6545 3.71933e-05 22.3945 3.71933e-05H12.3398V12.3398H24.6797Z"
        fill="#66B28A"
        stroke="#E1F3EA"
        strokeWidth="0.999997"
      />
      <path
        d="M12.3398 12.3399V24.6797H17.3164C17.5184 24.6797 17.7122 24.5994 17.855 24.4566L24.4565 17.855C24.5273 17.7843 24.5834 17.7003 24.6217 17.6079C24.6599 17.5155 24.6797 17.4165 24.6797 17.3164V12.3399H12.3398Z"
        fill="#66B28A"
      />
      <path
        d="M23.9179 17.3164H23.9184M12.3398 12.3399V24.6797H17.3164C17.5184 24.6797 17.7122 24.5994 17.855 24.4566L24.4565 17.855C24.5273 17.7843 24.5834 17.7003 24.6217 17.6079C24.6599 17.5155 24.6797 17.4165 24.6797 17.3164V12.3399H12.3398Z"
        stroke="#E1F3EA"
      />
      <path
        d="M0 12.3399V22.3945C0 23.6546 1.02512 24.6797 2.28515 24.6797H12.3398V12.3399H0Z"
        fill="#66B28A"
        stroke="#E1F3EA"
        strokeWidth="0.999997"
      />
      <path
        d="M7.94725 5.40821H6.93163V4.39259C6.93163 3.97192 6.59058 3.63087 6.16991 3.63087C5.74924 3.63087 5.4082 3.97192 5.4082 4.39259V5.40821H4.39258C3.97191 5.40821 3.63086 5.74926 3.63086 6.16993C3.63086 6.5906 3.97191 6.93165 4.39258 6.93165H5.4082V7.94727C5.4082 8.36794 5.74924 8.70898 6.16991 8.70898C6.59058 8.70898 6.93163 8.36794 6.93163 7.94727V6.93165H7.94725C8.36792 6.93165 8.70897 6.5906 8.70897 6.16993C8.70897 5.74926 8.36792 5.40821 7.94725 5.40821Z"
        fill="#E1F3EA"
      />
      <path
        d="M20.2871 6.93164H16.7324C16.3117 6.93164 15.9707 6.59059 15.9707 6.16992C15.9707 5.74925 16.3117 5.40821 16.7324 5.40821H20.2871C20.7078 5.40821 21.0488 5.74925 21.0488 6.16992C21.0488 6.59059 20.7078 6.93164 20.2871 6.93164Z"
        fill="#E1F3EA"
      />
      <path
        d="M7.24715 18.5098L7.97809 17.7788C8.27557 17.4814 8.27557 16.9991 7.97809 16.7017C7.68062 16.4041 7.1983 16.4041 6.90087 16.7017L6.16993 17.4326L5.43904 16.7017C5.14156 16.4041 4.65924 16.4041 4.36182 16.7017C4.06429 16.9991 4.06429 17.4814 4.36182 17.7788L5.09271 18.5098L4.36182 19.2407C4.06429 19.5381 4.06429 20.0205 4.36182 20.3179C4.43245 20.3887 4.5164 20.4449 4.60883 20.4832C4.70126 20.5215 4.80035 20.5412 4.9004 20.541C5.00046 20.5412 5.09955 20.5215 5.19199 20.4832C5.28443 20.4449 5.36839 20.3887 5.43904 20.3179L6.16993 19.587L6.90087 20.3179C6.97151 20.3887 7.05545 20.4449 7.14789 20.4832C7.24032 20.5215 7.33941 20.5412 7.43946 20.541C7.53951 20.5412 7.63861 20.5215 7.73105 20.4832C7.82349 20.4449 7.90744 20.3887 7.97809 20.3179C8.27557 20.0205 8.27557 19.5381 7.97809 19.2407L7.24715 18.5098Z"
        fill="#E1F3EA"
      />
      <path
        d="M10.7578 18.1289C10.7578 22.1929 14.0649 25.5 18.1289 25.5C22.1929 25.5 25.5 22.1929 25.5 18.1289C25.5 14.065 22.1929 10.7579 18.1289 10.7579C14.0649 10.7579 10.7578 14.065 10.7578 18.1289Z"
        fill="#66B28A"
        stroke="#E1F3EA"
      />
      <path
        d="M19.9062 20.4141H16.3516C15.9309 20.4141 15.5898 20.073 15.5898 19.6523C15.5898 19.2317 15.9309 18.8906 16.3516 18.8906H19.9062C20.3269 18.8906 20.668 19.2317 20.668 19.6523C20.668 20.073 20.3269 20.4141 19.9062 20.4141Z"
        fill="#E1F3EA"
      />
      <path
        d="M19.9062 17.3672H16.3516C15.9309 17.3672 15.5898 17.0261 15.5898 16.6055C15.5898 16.1848 15.9309 15.8438 16.3516 15.8438H19.9062C20.3269 15.8438 20.668 16.1848 20.668 16.6055C20.668 17.0261 20.3269 17.3672 19.9062 17.3672Z"
        fill="#E1F3EA"
      />
    </g>
    <defs>
      <clipPath id="clip0_3128_3726">
        <rect width="26" height="26" fill="white" />
      </clipPath>
    </defs>
  </IconBase>
);

/* *** */

export const Refresh = ({ className = '', ...props }: IconProps) => (
  <IconBase className={`${styles.refresh} ${className}`} {...props}>
    <g clipPath="url(#clip0_142_74)">
      <path
        d="M15.7161 9.10358C15.5442 9.08791 15.3922 9.21455 15.3765 9.38642L15.3351 9.84063C14.6326 8.73741 13.4132 8 12.0002 8C10.4802 8 9.14064 8.86753 8.47567 10.1696C8.39717 10.3233 8.45814 10.5115 8.61184 10.59C8.76557 10.6685 8.95378 10.6076 9.03228 10.4539C9.59504 9.35192 10.7252 8.625 12.0002 8.625C13.1623 8.625 14.2111 9.23017 14.812 10.1783L14.3664 9.86002C14.2259 9.75972 14.0308 9.79225 13.9305 9.93269C13.8302 10.0731 13.8627 10.2683 14.0031 10.3686L15.3543 11.3336C15.5523 11.4748 15.8255 11.3456 15.8471 11.1077L15.9989 9.44317C16.0146 9.27128 15.8879 9.11925 15.7161 9.10358Z"
        fill="#E6E6E6"
      />
      <path
        d="M15.3883 13.41C15.2346 13.3315 15.0464 13.3925 14.9679 13.5462C14.4051 14.6481 13.275 15.375 12 15.375C10.8378 15.375 9.78906 14.7699 9.18822 13.8218L9.6338 14.14C9.77425 14.2403 9.9694 14.2078 10.0697 14.0673C10.17 13.9269 10.1375 13.7317 9.99705 13.6314L8.64587 12.6664C8.45026 12.5266 8.17492 12.652 8.15305 12.8923L8.00131 14.5569C7.98564 14.7287 8.11228 14.8808 8.28414 14.8964C8.45623 14.9121 8.60806 14.7853 8.62372 14.6136L8.66512 14.1594C9.36759 15.2626 10.587 16 12 16C13.52 16 14.8595 15.1325 15.5245 13.8304C15.603 13.6767 15.542 13.4885 15.3883 13.41Z"
        fill="#E6E6E6"
      />
    </g>
    <circle cx="12" cy="12" r="8" fill="#CBE4F9" fillOpacity="0.24" />
    <defs>
      <clipPath id="clip0_142_74">
        <rect width="8" height="8" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </IconBase>
);

export const Home = (props?: IconProps) => {
  const fill = props?.fill ?? '#66B28A';

  return props?.isActive ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#E1F3EA" />
      <g clip-path="url(#clip0_5937_115861)">
        <path
          d="M20.5483 31.1174C17.9293 31.4684 15.785 33.4925 15.0494 36.177L6 30.7832L7.15555 29.1269C8.84397 26.7087 12.0369 26.0084 14.5345 27.5068L20.5483 31.1174Z"
          fill="#66B28A"
        />
        <path
          d="M21.3608 37.2534H25.8607C25.8607 34.9198 23.8456 33.029 21.3608 33.029C18.8752 33.029 16.8609 34.9207 16.8609 37.2534H21.3608Z"
          fill="#66B28A"
        />
        <path
          d="M27.965 23.127C25.3459 23.478 23.2016 25.502 22.4661 28.1866L13.4167 22.7928L14.5722 21.1365C16.2606 18.7183 19.4536 18.018 21.9511 19.5164L27.965 23.127Z"
          fill="#66B28A"
        />
        <path
          d="M28.7775 29.263H33.2774C33.2774 26.9294 31.2622 25.0386 28.7775 25.0386C26.2919 25.0386 24.2776 26.9303 24.2776 29.263H28.7775Z"
          fill="#66B28A"
        />
        <path
          d="M36.6875 15.9352C34.0685 16.2862 31.9242 18.3102 31.1886 20.9948L22.1392 15.601L23.2948 13.9447C24.9832 11.5265 28.1761 10.8262 30.6737 12.3246L36.6875 15.9352Z"
          fill="#66B28A"
        />
        <path
          d="M37.5 22.0695H41.9999C41.9999 19.7359 39.9848 17.845 37.5 17.845C35.0145 17.845 33.0002 19.7368 33.0002 22.0695H37.5Z"
          fill="#66B28A"
        />
      </g>
      <defs>
        <clipPath id="clip0_5937_115861">
          <rect
            width="36"
            height="25.7143"
            fill="white"
            transform="translate(6 11.5386)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#EEF2FD" />
      <g clip-path="url(#clip0_5937_115860)">
        <path
          d="M20.5483 31.1174C17.9293 31.4684 15.785 33.4925 15.0494 36.177L6 30.7832L7.15555 29.1269C8.84397 26.7087 12.0369 26.0084 14.5345 27.5068L20.5483 31.1174Z"
          fill="#C9D5F2"
        />
        <path
          d="M21.3608 37.2534H25.8607C25.8607 34.9198 23.8456 33.029 21.3608 33.029C18.8752 33.029 16.8609 34.9207 16.8609 37.2534H21.3608Z"
          fill="#C9D5F2"
        />
        <path
          d="M27.965 23.127C25.3459 23.478 23.2016 25.502 22.4661 28.1866L13.4167 22.7928L14.5722 21.1365C16.2606 18.7183 19.4536 18.018 21.9511 19.5164L27.965 23.127Z"
          fill="#C9D5F2"
        />
        <path
          d="M28.7775 29.263H33.2774C33.2774 26.9294 31.2622 25.0386 28.7775 25.0386C26.2919 25.0386 24.2776 26.9303 24.2776 29.263H28.7775Z"
          fill="#C9D5F2"
        />
        <path
          d="M36.6875 15.9352C34.0685 16.2862 31.9242 18.3102 31.1886 20.9948L22.1392 15.601L23.2948 13.9447C24.9832 11.5265 28.1761 10.8262 30.6737 12.3246L36.6875 15.9352Z"
          fill="#C9D5F2"
        />
        <path
          d="M37.5 22.0695H41.9999C41.9999 19.7359 39.9848 17.845 37.5 17.845C35.0145 17.845 33.0002 19.7368 33.0002 22.0695H37.5Z"
          fill="#C9D5F2"
        />
      </g>
      <defs>
        <clipPath id="clip0_5937_115860">
          <rect
            width="36"
            height="25.7143"
            fill="white"
            transform="translate(6 11.5386)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Mixing = (props?: IconProps) => {
  const fill = props?.fill ?? '#66B28A';

  return props?.isActive ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#E1F3EA" />
      <path
        d="M13.7331 26.9001H11.8665C10.8355 26.9001 9.9998 27.7359 9.9998 28.7668V37.1668C9.9998 38.1977 10.8355 39.0334 11.8665 39.0334H13.7331C14.7641 39.0334 15.5998 38.1977 15.5998 37.1668V28.7668C15.5998 27.7359 14.7641 26.9001 13.7331 26.9001Z"
        fill="#66B28A"
      />
      <path
        d="M21.1999 22.2331H19.3333C18.3023 22.2331 17.4666 23.0689 17.4666 24.0998V37.1665C17.4666 38.1974 18.3023 39.0331 19.3333 39.0331H21.1999C22.2309 39.0331 23.0666 38.1974 23.0666 37.1665V24.0998C23.0666 23.0689 22.2309 22.2331 21.1999 22.2331Z"
        fill="#66B28A"
      />
      <path
        d="M28.6667 29.6999H26.8001C25.7691 29.6999 24.9334 30.5357 24.9334 31.5666V37.1666C24.9334 38.1975 25.7691 39.0333 26.8001 39.0333H28.6667C29.6977 39.0333 30.5334 38.1975 30.5334 37.1666V31.5666C30.5334 30.5357 29.6977 29.6999 28.6667 29.6999Z"
        fill="#66B28A"
      />
      <path
        d="M36.1335 25.0329H34.2669C33.2359 25.0329 32.4002 25.8687 32.4002 26.8996V37.1663C32.4002 38.1972 33.2359 39.0329 34.2669 39.0329H36.1335C37.1645 39.0329 38.0002 38.1972 38.0002 37.1663V26.8996C38.0002 25.8687 37.1645 25.0329 36.1335 25.0329Z"
        fill="#66B28A"
      />
      <path
        d="M11.4002 22.2332L17.2008 15.5307C18.7761 13.7103 21.6371 13.8349 23.0484 15.7852L25.1464 18.6848C26.4933 20.5464 29.1861 20.7609 30.8108 19.1362L37.5138 12.4332"
        stroke="#66B28A"
        stroke-width="1.86667"
        stroke-linecap="round"
      />
    </svg>
  ) : (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#EEF2FD" />
      <path
        d="M13.7331 26.9001H11.8665C10.8355 26.9001 9.9998 27.7359 9.9998 28.7668V37.1668C9.9998 38.1977 10.8355 39.0334 11.8665 39.0334H13.7331C14.7641 39.0334 15.5998 38.1977 15.5998 37.1668V28.7668C15.5998 27.7359 14.7641 26.9001 13.7331 26.9001Z"
        fill="#C9D5F2"
      />
      <path
        d="M21.1999 22.2331H19.3333C18.3023 22.2331 17.4666 23.0689 17.4666 24.0998V37.1665C17.4666 38.1974 18.3023 39.0331 19.3333 39.0331H21.1999C22.2309 39.0331 23.0666 38.1974 23.0666 37.1665V24.0998C23.0666 23.0689 22.2309 22.2331 21.1999 22.2331Z"
        fill="#C9D5F2"
      />
      <path
        d="M28.6667 29.6999H26.8001C25.7691 29.6999 24.9334 30.5357 24.9334 31.5666V37.1666C24.9334 38.1975 25.7691 39.0333 26.8001 39.0333H28.6667C29.6977 39.0333 30.5334 38.1975 30.5334 37.1666V31.5666C30.5334 30.5357 29.6977 29.6999 28.6667 29.6999Z"
        fill="#C9D5F2"
      />
      <path
        d="M36.1335 25.0329H34.2669C33.2359 25.0329 32.4002 25.8687 32.4002 26.8996V37.1663C32.4002 38.1972 33.2359 39.0329 34.2669 39.0329H36.1335C37.1645 39.0329 38.0002 38.1972 38.0002 37.1663V26.8996C38.0002 25.8687 37.1645 25.0329 36.1335 25.0329Z"
        fill="#C9D5F2"
      />
      <path
        d="M11.4002 22.2332L17.2008 15.5307C18.7761 13.7103 21.6371 13.8349 23.0484 15.7852L25.1464 18.6848C26.4933 20.5464 29.1861 20.7609 30.8108 19.1362L37.5138 12.4332"
        stroke="#C9D5F2"
        stroke-width="1.86667"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const Prices = (props?: IconProps) => {
  const fill = props?.fill ?? '#66B28A';

  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.94773 23.8421L24.7898 9H35.8425C37.5793 9 39.0004 10.4211 39.0004 12.1579V23.2105L24.1583 38.0526C22.8951 39.3158 20.9214 39.3158 19.6583 38.0526L9.94773 28.3421C8.68458 27.0789 8.68458 25.1053 9.94773 23.8421ZM32.6846 13.7368C32.6846 14.6053 33.3951 15.3158 34.2635 15.3158C35.1319 15.3158 35.8425 14.6053 35.8425 13.7368C35.8425 12.8684 35.1319 12.1579 34.2635 12.1579C33.3951 12.1579 32.6846 12.8684 32.6846 13.7368Z"
        fill={fill}
      />
      <path
        d="M23.9356 25.9721L18.8434 20.88L20.2888 19.4346L25.3475 24.4933C25.7757 24.9216 26.1883 25.2004 26.5854 25.3297C26.9868 25.4546 27.3683 25.4569 27.7296 25.3364C28.0954 25.2115 28.4366 24.9907 28.7534 24.674C29.0478 24.3796 29.2597 24.0428 29.389 23.6636C29.5184 23.2844 29.5318 22.8874 29.4292 22.4725C29.3311 22.0621 29.079 21.6539 28.6731 21.248L26.7727 19.3476L18.4888 27.6316L16.6487 25.7914L26.3913 16.0488L30.1251 19.7826C30.8879 20.5454 31.4032 21.3283 31.6708 22.1312C31.9385 22.9342 31.9808 23.7126 31.7979 24.4665C31.6195 25.2249 31.2269 25.9074 30.6203 26.5141C29.9779 27.1565 29.2798 27.5602 28.5259 27.7252C27.7764 27.8948 27.0091 27.8323 26.224 27.5379C25.4478 27.2435 24.685 26.7215 23.9356 25.9721ZM23.5742 26.8687L22.1222 28.3208L16.7624 22.961L18.2144 21.509L23.5742 26.8687Z"
        fill={fill}
      />
    </svg>
  );
};

export const ConservationIcon = (props?: IconProps) => {
  const fill = props?.fill ?? '#66B28A';

  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1011_3117)">
        <path
          d="M20.5483 32.079C17.9293 32.43 15.785 34.454 15.0494 37.1386L6 31.7448L7.15555 30.0885C8.84397 27.6703 12.0369 26.97 14.5345 28.4684L20.5483 32.079Z"
          fill={fill}
        />
        <path
          d="M21.3609 38.2151H25.8607C25.8607 35.8816 23.8456 33.9907 21.3609 33.9907C18.8753 33.9907 16.861 35.8825 16.861 38.2151H21.3609Z"
          fill={fill}
        />
        <path
          d="M27.9649 24.0888C25.3459 24.4398 23.2016 26.4638 22.466 29.1484L13.4166 23.7545L14.5722 22.0983C16.2606 19.68 19.4535 18.9798 21.9511 20.4782L27.9649 24.0888Z"
          fill={fill}
        />
        <path
          d="M28.7775 30.2247H33.2774C33.2774 27.8911 31.2622 26.0002 28.7775 26.0002C26.2919 26.0002 24.2776 27.892 24.2776 30.2247H28.7775Z"
          fill={fill}
        />
        <path
          d="M36.6875 16.8969C34.0685 17.2479 31.9241 19.2719 31.1886 21.9565L22.1392 16.5626L23.2947 14.9064C24.9831 12.4881 28.1761 11.7879 30.6736 13.2863L36.6875 16.8969Z"
          fill={fill}
        />
        <path
          d="M37.5 23.0311H41.9999C41.9999 20.6975 39.9847 18.8066 37.5 18.8066C35.0144 18.8066 33.0001 20.6984 33.0001 23.0311H37.5Z"
          fill={fill}
        />
      </g>
      <circle cx="15.2956" cy="17.2957" r="8.75472" fill="#E1F3EA" />
      <path
        d="M16.7696 23.29C16.6489 23.3201 16.5272 23.3465 16.4049 23.3691C16.0866 23.4282 15.8761 23.7344 15.935 24.0529C15.9628 24.2036 16.0486 24.3374 16.1739 24.4254C16.2378 24.4705 16.31 24.5024 16.3864 24.5191C16.4628 24.5358 16.5417 24.537 16.6185 24.5226C16.7643 24.4956 16.9092 24.4641 17.0531 24.4283C17.3674 24.3501 17.5589 24.0316 17.4805 23.7175C17.4022 23.4031 17.0841 23.2117 16.7696 23.29ZM21.1073 15.4277C21.1467 15.5469 21.2233 15.6503 21.3259 15.7225C21.4728 15.826 21.6651 15.8608 21.8485 15.8001C22.1561 15.698 22.3228 15.3664 22.221 15.0589C22.1744 14.9182 22.1235 14.779 22.0684 14.6413C21.9481 14.3405 21.6069 14.1941 21.306 14.3144C21.0053 14.4347 20.8588 14.776 20.9792 15.0769C21.0255 15.1925 21.0682 15.3095 21.1073 15.4277ZM18.6756 22.4525C18.5717 22.5212 18.4657 22.5867 18.3578 22.6489C18.0771 22.8108 17.981 23.1696 18.1428 23.4502C18.1852 23.5239 18.2432 23.5875 18.3127 23.6365C18.4936 23.7639 18.7394 23.7829 18.944 23.6651C19.0724 23.591 19.1986 23.513 19.3223 23.4313C19.5925 23.2528 19.6669 22.8889 19.4883 22.6186C19.3097 22.3482 18.9459 22.2739 18.6756 22.4525ZM22.5857 17.066C22.573 16.7423 22.3003 16.4903 21.9764 16.5029C21.653 16.5157 21.4008 16.7885 21.4135 17.1121C21.4184 17.2358 21.4196 17.3614 21.4168 17.485C21.4122 17.6881 21.5115 17.869 21.6658 17.9778C21.761 18.0449 21.874 18.082 21.9903 18.0845C22.3141 18.0917 22.5824 17.8349 22.5896 17.511C22.5928 17.3633 22.5916 17.2136 22.5857 17.066ZM21.0116 20.9094C20.752 20.7147 20.3847 20.7675 20.1903 21.0267C20.1155 21.1262 20.0378 21.2235 19.9571 21.3183C19.7472 21.5649 19.7769 21.9352 20.0234 22.1451C20.0375 22.1571 20.0517 22.168 20.0664 22.1783C20.3115 22.3511 20.6521 22.3114 20.8503 22.0788C20.9466 21.9656 21.0394 21.8495 21.1286 21.7306C21.3231 21.4715 21.2705 21.1039 21.0116 20.9094ZM21.8738 18.789C21.5647 18.6921 21.2355 18.8642 21.1387 19.1733C21.1014 19.2922 21.0605 19.4099 21.0162 19.5263C20.9188 19.7821 21.0121 20.0635 21.226 20.2144C21.2661 20.2426 21.3096 20.2657 21.3554 20.2831C21.6581 20.3986 21.997 20.2467 22.1123 19.944C22.165 19.8055 22.2136 19.6655 22.258 19.5242C22.3548 19.215 22.1829 18.886 21.8738 18.789ZM14.2104 23.3743C13.6902 23.2813 13.1844 23.1205 12.7059 22.8962C12.7003 22.8932 12.6952 22.8899 12.6893 22.8872C12.5765 22.8342 12.4653 22.7779 12.3559 22.7184C12.3555 22.7179 12.3548 22.7177 12.3542 22.7174C12.1531 22.6066 11.9583 22.4849 11.7706 22.3527C9.01133 20.409 8.34789 16.5828 10.2917 13.8235C10.7144 13.2238 11.2259 12.7234 11.7962 12.3268C11.8032 12.3219 11.8102 12.317 11.8172 12.3121C13.8267 10.9275 16.5553 10.8342 18.689 12.257L18.2307 12.9192C18.1033 13.1035 18.1817 13.2378 18.4047 13.2177L20.3954 13.0395C20.6187 13.0194 20.7523 12.8262 20.6922 12.6106L20.1577 10.6845C20.0978 10.4686 19.9446 10.4428 19.8171 10.627L19.3577 11.2908C17.7918 10.2396 15.9137 9.83879 14.0496 10.162C13.863 10.1944 13.6777 10.234 13.4941 10.2806C13.4927 10.2809 13.4916 10.281 13.4904 10.2813C13.4834 10.283 13.4762 10.2853 13.4694 10.2872C11.8619 10.7 10.4594 11.6375 9.4586 12.9752C9.45017 12.9852 9.44148 12.995 9.43351 13.0059C9.40008 13.051 9.36719 13.0965 9.33487 13.1424C9.28177 13.2178 9.23014 13.2942 9.17998 13.3716C9.17374 13.3809 9.16897 13.3904 9.16352 13.3997C8.33766 14.6795 7.93932 16.159 8.00764 17.6652C8.00779 17.6702 8.00751 17.6752 8.00764 17.6802C8.01442 17.8283 8.0258 17.9761 8.04176 18.1234C8.04261 18.1329 8.04471 18.1419 8.04631 18.1513C8.06262 18.2998 8.08352 18.4478 8.10898 18.595C8.37069 20.1049 9.08294 21.4635 10.1502 22.5207C10.1527 22.5232 10.1553 22.5259 10.1578 22.5284C10.1586 22.5294 10.1596 22.5299 10.1605 22.5308C10.4499 22.8164 10.7625 23.0776 11.0949 23.3118C11.9738 23.931 12.9524 24.3404 14.0034 24.529C14.3223 24.5863 14.6269 24.374 14.6841 24.0553C14.7413 23.7363 14.5292 23.4314 14.2104 23.3743Z"
        fill={fill}
      />
      <path
        d="M14.9357 12.6096C14.6734 12.6096 14.4609 12.8223 14.4609 13.0842V17.8125L18.7853 20.0479C18.8525 20.0828 18.9271 20.1009 19.0027 20.1009C19.1745 20.1009 19.3404 20.0074 19.4247 19.8442C19.545 19.6113 19.454 19.3251 19.2211 19.2048L15.41 17.2345V13.0842C15.4099 12.8223 15.1977 12.6096 14.9357 12.6096Z"
        fill={fill}
      />
      <defs>
        <clipPath id="clip0_1011_3117">
          <rect
            width="36"
            height="25.7143"
            fill="white"
            transform="translate(6 12.5002)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MixingSimple = (props?: IconProps) => {
  const fill = props?.fill ?? '#66B28A';

  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_290_3068)">
        <mask id="path-2-inside-1_290_3068" fill="white">
          <path d="M9 16H17V26H9V16Z" />
        </mask>
        <path d="M9 16H17V26H9V16Z" fill={fill} />
        <path
          d="M17 24H9V28H17V24Z"
          fill={fill}
          mask="url(#path-2-inside-1_290_3068)"
        />
        <mask id="path-4-inside-2_290_3068" fill="white">
          <path d="M18 16H25V26H18V16Z" />
        </mask>
        <path d="M18 16H25V26H18V16Z" fill={fill} />
        <path
          d="M25 24H18V28H25V24Z"
          fill={fill}
          mask="url(#path-4-inside-2_290_3068)"
        />
        <mask id="path-6-inside-3_290_3068" fill="white">
          <path d="M26 16H34V26H26V16Z" />
        </mask>
        <path d="M26 16H34V26H26V16Z" fill={fill} />
        <path
          d="M34 24H26V28H34V24Z"
          fill={fill}
          mask="url(#path-6-inside-3_290_3068)"
        />
        <rect x="11" y="27" width="21" height="5" fill={fill} />
        <circle cx="17" cy="32" r="2.5" fill={fill} stroke="#E1F3EA" />
        <circle cx="26" cy="32" r="2.5" fill={fill} stroke="#E1F3EA" />
        <rect x="33" y="28" width="8" height="3" fill={fill} />
        <line x1="9" y1="25" x2="34" y2="25" stroke={fill} strokeWidth="2" />
      </g>
      <defs>
        <clipPath id="clip0_290_3068">
          <rect width="31" height="19" fill="white" transform="translate(9 16)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconSearch = () => (
  <IconBase width={20} height={20} fill="none">
    <path
      d="M19 19L13.8033 13.8033M13.8033 13.8033C15.1605 12.4461 16 10.5711 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16C10.5711 16 12.4461 15.1605 13.8033 13.8033Z"
      stroke="#007E3C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
);

export const IconFilter = () => (
  <IconBase width={20} height={20} fill="none">
    <path
      d="M10.0001 1C12.7548 1 15.4552 1.23205 18.0831 1.67767C18.6159 1.76803 19 2.23355 19 2.77402V3.81802C19 4.41476 18.7629 4.98705 18.341 5.40901L12.909 10.841C12.4871 11.2629 12.25 11.8352 12.25 12.432V15.3594C12.25 16.2117 11.7685 16.9908 11.0062 17.3719L7.75 19V12.432C7.75 11.8352 7.51295 11.2629 7.09099 10.841L1.65901 5.40901C1.23705 4.98705 1 4.41476 1 3.81802V2.77404C1 2.23357 1.38408 1.76805 1.91694 1.67769C4.54479 1.23206 7.24533 1 10.0001 1Z"
      stroke="#7E89A5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
);

export const IconArrowDown = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.73017 7.20938C6.02875 6.92228 6.50353 6.93159 6.79063 7.23017L10.5 11.1679L14.2094 7.23017C14.4965 6.93159 14.9713 6.92228 15.2698 7.20938C15.5684 7.49647 15.5777 7.97125 15.2906 8.26983L11.0406 12.7698C10.8992 12.9169 10.704 13 10.5 13C10.296 13 10.1008 12.9169 9.95938 12.7698L5.70938 8.26983C5.42228 7.97125 5.43159 7.49647 5.73017 7.20938Z"
      fill="white"
    />
  </svg>
);

export const IconArrowUp = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2698 12.7906C14.9713 13.0777 14.4965 13.0684 14.2094 12.7698L10.5 8.83208L6.79062 12.7698C6.50353 13.0684 6.02875 13.0777 5.73017 12.7906C5.43159 12.5035 5.42228 12.0287 5.70937 11.7302L9.95937 7.23017C10.1008 7.08311 10.296 7 10.5 7C10.704 7 10.8992 7.08311 11.0406 7.23017L15.2906 11.7302C15.5777 12.0287 15.5684 12.5035 15.2698 12.7906Z"
      fill="white"
    />
  </svg>
);

export const WarehouseSleeveList = () => (
  <svg
    width="26"
    height="19"
    viewBox="0 0 26 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5071 14.1405C8.6156 14.394 7.06693 15.8558 6.53567 17.7947L0 13.8991L0.834565 12.7029C2.05398 10.9564 4.36 10.4507 6.1638 11.5328L10.5071 14.1405Z"
      fill="#E73A42"
    />
    <path
      d="M11.0939 18.5719H14.3438C14.3438 16.8865 12.8884 15.5209 11.0939 15.5209C9.29877 15.5209 7.84399 16.8872 7.84399 18.5719H11.0939Z"
      fill="#E73A42"
    />
    <path
      d="M15.8636 8.36957C13.972 8.62307 12.4234 10.0849 11.8921 12.0237L5.35645 8.12816L6.19101 6.93198C7.41043 5.18547 9.71644 4.67974 11.5202 5.76191L15.8636 8.36957Z"
      fill="#E73A42"
    />
    <path
      d="M16.4504 12.801H19.7003C19.7003 11.1156 18.2449 9.75 16.4504 9.75C14.6552 9.75 13.2004 11.1162 13.2004 12.801H16.4504Z"
      fill="#E73A42"
    />
    <path
      d="M22.1632 3.17535C20.2717 3.42886 18.7231 4.89065 18.1918 6.82951L11.6561 2.93395L12.4907 1.73777C13.7101 -0.00873983 16.0161 -0.514475 17.8199 0.567696L22.1632 3.17535Z"
      fill="#E73A42"
    />
    <path
      d="M22.75 7.60554H26C26 5.92018 24.5446 4.55457 22.75 4.55457C20.9549 4.55457 19.5001 5.92081 19.5001 7.60554H22.75Z"
      fill="#E73A42"
    />
  </svg>
);

export const WarehouseStationaryList = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.512821 4.78631C0.202282 4.9157 0 5.21913 0 5.55555V16.6667H2.5V7.49999C2.5 7.03975 2.8731 6.66665 3.33333 6.66665H16.6667C17.1269 6.66665 17.5 7.03975 17.5 7.49999V16.6667H20V5.55555C20 5.21913 19.7977 4.9157 19.4872 4.78631L10.3205 0.966871C10.1154 0.881404 9.88458 0.881404 9.6795 0.966871L0.512821 4.78631Z"
      fill="#007E3C"
    />
    <path
      d="M15 13.3333H4.99996C4.53972 13.3333 4.16663 13.7064 4.16663 14.1666V15.8333C4.16663 16.2936 4.53972 16.6666 4.99996 16.6666H15C15.4602 16.6666 15.8333 16.2936 15.8333 15.8333V14.1666C15.8333 13.7064 15.4602 13.3333 15 13.3333Z"
      fill="#007E3C"
    />
    <path
      d="M15 8.33331H4.99996C4.53972 8.33331 4.16663 8.70641 4.16663 9.16665V10.8333C4.16663 11.2936 4.53972 11.6666 4.99996 11.6666H15C15.4602 11.6666 15.8333 11.2936 15.8333 10.8333V9.16665C15.8333 8.70641 15.4602 8.33331 15 8.33331Z"
      fill="#007E3C"
    />
  </svg>
);

export const WarehouseSleeveBadge = () => (
  <svg
    width="97"
    height="27"
    viewBox="0 0 97 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="97" height="27" rx="8" fill="#F1898E" />
    <g clipPath="url(#clip0_197_5552)">
      <path
        d="M16.4865 17.4212C14.9588 17.6259 13.7079 18.8066 13.2788 20.3726L8 17.2262L8.67407 16.26C9.65898 14.8494 11.5215 14.4409 12.9785 15.315L16.4865 17.4212Z"
        fill="white"
      />
      <path
        d="M16.9604 21.0004H19.5853C19.5853 19.6391 18.4098 18.5361 16.9604 18.5361C15.5105 18.5361 14.3354 19.6396 14.3354 21.0004H16.9604Z"
        fill="white"
      />
      <path
        d="M20.8127 12.76C19.2849 12.9648 18.0341 14.1455 17.605 15.7115L12.3262 12.565L13.0002 11.5989C13.9852 10.1883 15.8477 9.77978 17.3046 10.6538L20.8127 12.76Z"
        fill="white"
      />
      <path
        d="M21.287 16.3392H23.912C23.912 14.978 22.7365 13.875 21.287 13.875C19.8371 13.875 18.6621 14.9785 18.6621 16.3392H21.287Z"
        fill="white"
      />
      <path
        d="M25.9011 8.56471C24.3733 8.76946 23.1225 9.95014 22.6934 11.5161L17.4146 8.36973L18.0886 7.40358C19.0735 5.99294 20.9361 5.58446 22.393 6.45852L25.9011 8.56471Z"
        fill="white"
      />
      <path
        d="M26.3749 12.143H28.9999C28.9999 10.7817 27.8244 9.67871 26.3749 9.67871C24.925 9.67871 23.75 10.7822 23.75 12.143H26.3749Z"
        fill="white"
      />
    </g>
    <path
      d="M39.5469 12.1719V22.25H38.0938V10.5469H39.4219L39.5469 12.1719ZM45.2422 14.7031V14.8672C45.2422 15.4818 45.1693 16.0521 45.0234 16.5781C44.8776 17.099 44.6641 17.5521 44.3828 17.9375C44.1068 18.3229 43.7656 18.6224 43.3594 18.8359C42.9531 19.0495 42.487 19.1562 41.9609 19.1562C41.4245 19.1562 40.9505 19.0677 40.5391 18.8906C40.1276 18.7135 39.7786 18.4557 39.4922 18.1172C39.2057 17.7786 38.9766 17.3724 38.8047 16.8984C38.638 16.4245 38.5234 15.8906 38.4609 15.2969V14.4219C38.5234 13.7969 38.6406 13.237 38.8125 12.7422C38.9844 12.2474 39.2109 11.8255 39.4922 11.4766C39.7786 11.1224 40.125 10.8542 40.5312 10.6719C40.9375 10.4844 41.4062 10.3906 41.9375 10.3906C42.4688 10.3906 42.9401 10.4948 43.3516 10.7031C43.763 10.9062 44.1094 11.1979 44.3906 11.5781C44.6719 11.9583 44.8828 12.4141 45.0234 12.9453C45.1693 13.4714 45.2422 14.0573 45.2422 14.7031ZM43.7891 14.8672V14.7031C43.7891 14.2812 43.7448 13.8854 43.6562 13.5156C43.5677 13.1406 43.4297 12.8125 43.2422 12.5312C43.0599 12.2448 42.8255 12.0208 42.5391 11.8594C42.2526 11.6927 41.9115 11.6094 41.5156 11.6094C41.151 11.6094 40.8333 11.6719 40.5625 11.7969C40.2969 11.9219 40.0703 12.0911 39.8828 12.3047C39.6953 12.513 39.5417 12.7526 39.4219 13.0234C39.3073 13.2891 39.2214 13.5651 39.1641 13.8516V15.875C39.2682 16.2396 39.4141 16.5833 39.6016 16.9062C39.7891 17.224 40.0391 17.4818 40.3516 17.6797C40.6641 17.8724 41.0573 17.9688 41.5312 17.9688C41.9219 17.9688 42.2578 17.888 42.5391 17.7266C42.8255 17.5599 43.0599 17.3333 43.2422 17.0469C43.4297 16.7604 43.5677 16.4323 43.6562 16.0625C43.7448 15.6875 43.7891 15.2891 43.7891 14.8672ZM49.3672 18.125L51.7188 10.5469H53.2656L49.875 20.3047C49.7969 20.513 49.6927 20.737 49.5625 20.9766C49.4375 21.2214 49.276 21.4531 49.0781 21.6719C48.8802 21.8906 48.6406 22.0677 48.3594 22.2031C48.0833 22.3438 47.7526 22.4141 47.3672 22.4141C47.2526 22.4141 47.1068 22.3984 46.9297 22.3672C46.7526 22.3359 46.6276 22.3099 46.5547 22.2891L46.5469 21.1172C46.5885 21.1224 46.6536 21.1276 46.7422 21.1328C46.8359 21.1432 46.901 21.1484 46.9375 21.1484C47.2656 21.1484 47.5443 21.1042 47.7734 21.0156C48.0026 20.9323 48.1953 20.7891 48.3516 20.5859C48.513 20.388 48.651 20.1146 48.7656 19.7656L49.3672 18.125ZM47.6406 10.5469L49.8359 17.1094L50.2109 18.6328L49.1719 19.1641L46.0625 10.5469H47.6406ZM56.1406 10.5469V19H54.6953V10.5469H56.1406ZM61.6875 10.5469L57.6797 15.3906H55.6562L55.4375 14.125H57.0938L59.9297 10.5469H61.6875ZM60.1328 19L57.0234 15.1719L57.9531 14.125L61.9688 19H60.1328ZM68.2109 17.5547V13.2031C68.2109 12.8698 68.1432 12.5807 68.0078 12.3359C67.8776 12.0859 67.6797 11.8932 67.4141 11.7578C67.1484 11.6224 66.8203 11.5547 66.4297 11.5547C66.0651 11.5547 65.7448 11.6172 65.4688 11.7422C65.1979 11.8672 64.9844 12.0312 64.8281 12.2344C64.6771 12.4375 64.6016 12.6562 64.6016 12.8906H63.1562C63.1562 12.5885 63.2344 12.2891 63.3906 11.9922C63.5469 11.6953 63.7708 11.4271 64.0625 11.1875C64.3594 10.9427 64.7135 10.75 65.125 10.6094C65.5417 10.4635 66.0052 10.3906 66.5156 10.3906C67.1302 10.3906 67.6719 10.4948 68.1406 10.7031C68.6146 10.9115 68.9844 11.2266 69.25 11.6484C69.5208 12.0651 69.6562 12.5885 69.6562 13.2188V17.1562C69.6562 17.4375 69.6797 17.737 69.7266 18.0547C69.7786 18.3724 69.8542 18.6458 69.9531 18.875V19H68.4453C68.3724 18.8333 68.3151 18.612 68.2734 18.3359C68.2318 18.0547 68.2109 17.7943 68.2109 17.5547ZM68.4609 13.875L68.4766 14.8906H67.0156C66.6042 14.8906 66.237 14.9245 65.9141 14.9922C65.5911 15.0547 65.3203 15.151 65.1016 15.2812C64.8828 15.4115 64.7161 15.5755 64.6016 15.7734C64.487 15.9661 64.4297 16.1927 64.4297 16.4531C64.4297 16.7188 64.4896 16.9609 64.6094 17.1797C64.7292 17.3984 64.9089 17.5729 65.1484 17.7031C65.3932 17.8281 65.6927 17.8906 66.0469 17.8906C66.4896 17.8906 66.8802 17.7969 67.2188 17.6094C67.5573 17.4219 67.8255 17.1927 68.0234 16.9219C68.2266 16.651 68.3359 16.388 68.3516 16.1328L68.9688 16.8281C68.9323 17.0469 68.8333 17.2891 68.6719 17.5547C68.5104 17.8203 68.2943 18.0755 68.0234 18.3203C67.7578 18.5599 67.4401 18.7604 67.0703 18.9219C66.7057 19.0781 66.2943 19.1562 65.8359 19.1562C65.263 19.1562 64.7604 19.0443 64.3281 18.8203C63.901 18.5964 63.5677 18.2969 63.3281 17.9219C63.0938 17.5417 62.9766 17.1172 62.9766 16.6484C62.9766 16.1953 63.0651 15.7969 63.2422 15.4531C63.4193 15.1042 63.6745 14.8151 64.0078 14.5859C64.3411 14.3516 64.7422 14.1745 65.2109 14.0547C65.6797 13.9349 66.2031 13.875 66.7812 13.875H68.4609ZM75.8984 15.2812H73.125L73.1094 14.125H75.375C75.8229 14.125 76.1953 14.0807 76.4922 13.9922C76.7943 13.9036 77.0208 13.7708 77.1719 13.5938C77.3229 13.4167 77.3984 13.1979 77.3984 12.9375C77.3984 12.7344 77.3542 12.5573 77.2656 12.4062C77.1823 12.25 77.0547 12.1224 76.8828 12.0234C76.7109 11.9193 76.4974 11.8438 76.2422 11.7969C75.9922 11.7448 75.6979 11.7188 75.3594 11.7188H73.5078V19H72.0625V10.5469H75.3594C75.8958 10.5469 76.3776 10.5938 76.8047 10.6875C77.237 10.7812 77.6042 10.9245 77.9062 11.1172C78.2135 11.3047 78.4479 11.5443 78.6094 11.8359C78.7708 12.1276 78.8516 12.4714 78.8516 12.8672C78.8516 13.1224 78.7995 13.3646 78.6953 13.5938C78.5911 13.8229 78.4375 14.026 78.2344 14.2031C78.0312 14.3802 77.7812 14.526 77.4844 14.6406C77.1875 14.75 76.8464 14.8203 76.4609 14.8516L75.8984 15.2812ZM75.8984 19H72.6016L73.3203 17.8281H75.8984C76.2995 17.8281 76.6328 17.7786 76.8984 17.6797C77.1641 17.5755 77.362 17.4297 77.4922 17.2422C77.6276 17.0495 77.6953 16.8203 77.6953 16.5547C77.6953 16.2891 77.6276 16.0625 77.4922 15.875C77.362 15.6823 77.1641 15.5365 76.8984 15.4375C76.6328 15.3333 76.2995 15.2812 75.8984 15.2812H73.7031L73.7188 14.125H76.4609L76.9844 14.5625C77.4479 14.599 77.8411 14.7135 78.1641 14.9062C78.487 15.099 78.7318 15.3438 78.8984 15.6406C79.0651 15.9323 79.1484 16.25 79.1484 16.5938C79.1484 16.9896 79.0729 17.3385 78.9219 17.6406C78.776 17.9427 78.5625 18.1953 78.2812 18.3984C78 18.5964 77.6589 18.7474 77.2578 18.8516C76.8568 18.9505 76.4036 19 75.8984 19ZM86.0703 17.5547V13.2031C86.0703 12.8698 86.0026 12.5807 85.8672 12.3359C85.737 12.0859 85.5391 11.8932 85.2734 11.7578C85.0078 11.6224 84.6797 11.5547 84.2891 11.5547C83.9245 11.5547 83.6042 11.6172 83.3281 11.7422C83.0573 11.8672 82.8438 12.0312 82.6875 12.2344C82.5365 12.4375 82.4609 12.6562 82.4609 12.8906H81.0156C81.0156 12.5885 81.0938 12.2891 81.25 11.9922C81.4062 11.6953 81.6302 11.4271 81.9219 11.1875C82.2188 10.9427 82.5729 10.75 82.9844 10.6094C83.401 10.4635 83.8646 10.3906 84.375 10.3906C84.9896 10.3906 85.5312 10.4948 86 10.7031C86.474 10.9115 86.8438 11.2266 87.1094 11.6484C87.3802 12.0651 87.5156 12.5885 87.5156 13.2188V17.1562C87.5156 17.4375 87.5391 17.737 87.5859 18.0547C87.638 18.3724 87.7135 18.6458 87.8125 18.875V19H86.3047C86.2318 18.8333 86.1745 18.612 86.1328 18.3359C86.0911 18.0547 86.0703 17.7943 86.0703 17.5547ZM86.3203 13.875L86.3359 14.8906H84.875C84.4635 14.8906 84.0964 14.9245 83.7734 14.9922C83.4505 15.0547 83.1797 15.151 82.9609 15.2812C82.7422 15.4115 82.5755 15.5755 82.4609 15.7734C82.3464 15.9661 82.2891 16.1927 82.2891 16.4531C82.2891 16.7188 82.349 16.9609 82.4688 17.1797C82.5885 17.3984 82.7682 17.5729 83.0078 17.7031C83.2526 17.8281 83.5521 17.8906 83.9062 17.8906C84.349 17.8906 84.7396 17.7969 85.0781 17.6094C85.4167 17.4219 85.6849 17.1927 85.8828 16.9219C86.0859 16.651 86.1953 16.388 86.2109 16.1328L86.8281 16.8281C86.7917 17.0469 86.6927 17.2891 86.5312 17.5547C86.3698 17.8203 86.1536 18.0755 85.8828 18.3203C85.6172 18.5599 85.2995 18.7604 84.9297 18.9219C84.5651 19.0781 84.1536 19.1562 83.6953 19.1562C83.1224 19.1562 82.6198 19.0443 82.1875 18.8203C81.7604 18.5964 81.4271 18.2969 81.1875 17.9219C80.9531 17.5417 80.8359 17.1172 80.8359 16.6484C80.8359 16.1953 80.9245 15.7969 81.1016 15.4531C81.2786 15.1042 81.5339 14.8151 81.8672 14.5859C82.2005 14.3516 82.6016 14.1745 83.0703 14.0547C83.5391 13.9349 84.0625 13.875 84.6406 13.875H86.3203Z"
      fill="white"
    />
    <defs>
      <clipPath id="clip0_197_5552">
        <rect width="21" height="15" fill="white" transform="translate(8 6)" />
      </clipPath>
    </defs>
  </svg>
);

export const WarehouseStationaryBadge = () => (
  <svg
    width="155"
    height="28"
    viewBox="0 0 155 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="155" height="28" rx="8" fill="#E1F3EA" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.51282 8.78631C8.20228 8.9157 8 9.21913 8 9.55555V20.6667H10.5V11.5C10.5 11.0398 10.8731 10.6667 11.3333 10.6667H24.6667C25.1269 10.6667 25.5 11.0398 25.5 11.5V20.6667H28V9.55555C28 9.21913 27.7977 8.9157 27.4872 8.78631L18.3205 4.96687C18.1154 4.8814 17.8846 4.8814 17.6795 4.96687L8.51282 8.78631Z"
      fill="#007E3C"
    />
    <path
      d="M23.0003 17.3333H13.0003C12.5401 17.3333 12.167 17.7064 12.167 18.1666V19.8333C12.167 20.2936 12.5401 20.6666 13.0003 20.6666H23.0003C23.4606 20.6666 23.8337 20.2936 23.8337 19.8333V18.1666C23.8337 17.7064 23.4606 17.3333 23.0003 17.3333Z"
      fill="#007E3C"
    />
    <path
      d="M23.0003 12.3333H13.0003C12.5401 12.3333 12.167 12.7064 12.167 13.1666V14.8333C12.167 15.2936 12.5401 15.6666 13.0003 15.6666H23.0003C23.4606 15.6666 23.8337 15.2936 23.8337 14.8333V13.1666C23.8337 12.7064 23.4606 12.3333 23.0003 12.3333Z"
      fill="#007E3C"
    />
    <path
      d="M40.4844 18.4688C40.8281 18.4688 41.1458 18.3984 41.4375 18.2578C41.7292 18.1172 41.9688 17.9245 42.1562 17.6797C42.3438 17.4297 42.4505 17.1458 42.4766 16.8281H43.8516C43.8255 17.3281 43.6562 17.7943 43.3438 18.2266C43.0365 18.6536 42.6328 19 42.1328 19.2656C41.6328 19.526 41.0833 19.6562 40.4844 19.6562C39.849 19.6562 39.2943 19.5443 38.8203 19.3203C38.3516 19.0964 37.9609 18.7891 37.6484 18.3984C37.3411 18.0078 37.1094 17.5599 36.9531 17.0547C36.8021 16.5443 36.7266 16.0052 36.7266 15.4375V15.1094C36.7266 14.5417 36.8021 14.0052 36.9531 13.5C37.1094 12.9896 37.3411 12.5391 37.6484 12.1484C37.9609 11.7578 38.3516 11.4505 38.8203 11.2266C39.2943 11.0026 39.849 10.8906 40.4844 10.8906C41.1458 10.8906 41.724 11.026 42.2188 11.2969C42.7135 11.5625 43.1016 11.9271 43.3828 12.3906C43.6693 12.849 43.8255 13.3698 43.8516 13.9531H42.4766C42.4505 13.6042 42.3516 13.2891 42.1797 13.0078C42.013 12.7266 41.7839 12.5026 41.4922 12.3359C41.2057 12.1641 40.8698 12.0781 40.4844 12.0781C40.0417 12.0781 39.6693 12.1667 39.3672 12.3438C39.0703 12.5156 38.8333 12.75 38.6562 13.0469C38.4844 13.3385 38.3594 13.6641 38.2812 14.0234C38.2083 14.3776 38.1719 14.7396 38.1719 15.1094V15.4375C38.1719 15.8073 38.2083 16.1719 38.2812 16.5312C38.3542 16.8906 38.4766 17.2161 38.6484 17.5078C38.8255 17.7995 39.0625 18.0339 39.3594 18.2109C39.6615 18.3828 40.0365 18.4688 40.4844 18.4688ZM48.9219 11.0469V19.5H47.4688V11.0469H48.9219ZM51.7578 11.0469V12.2188H44.6875V11.0469H51.7578ZM58.0391 18.0547V13.7031C58.0391 13.3698 57.9714 13.0807 57.8359 12.8359C57.7057 12.5859 57.5078 12.3932 57.2422 12.2578C56.9766 12.1224 56.6484 12.0547 56.2578 12.0547C55.8932 12.0547 55.5729 12.1172 55.2969 12.2422C55.026 12.3672 54.8125 12.5312 54.6562 12.7344C54.5052 12.9375 54.4297 13.1562 54.4297 13.3906H52.9844C52.9844 13.0885 53.0625 12.7891 53.2188 12.4922C53.375 12.1953 53.599 11.9271 53.8906 11.6875C54.1875 11.4427 54.5417 11.25 54.9531 11.1094C55.3698 10.9635 55.8333 10.8906 56.3438 10.8906C56.9583 10.8906 57.5 10.9948 57.9688 11.2031C58.4427 11.4115 58.8125 11.7266 59.0781 12.1484C59.349 12.5651 59.4844 13.0885 59.4844 13.7188V17.6562C59.4844 17.9375 59.5078 18.237 59.5547 18.5547C59.6068 18.8724 59.6823 19.1458 59.7812 19.375V19.5H58.2734C58.2005 19.3333 58.1432 19.112 58.1016 18.8359C58.0599 18.5547 58.0391 18.2943 58.0391 18.0547ZM58.2891 14.375L58.3047 15.3906H56.8438C56.4323 15.3906 56.0651 15.4245 55.7422 15.4922C55.4193 15.5547 55.1484 15.651 54.9297 15.7812C54.7109 15.9115 54.5443 16.0755 54.4297 16.2734C54.3151 16.4661 54.2578 16.6927 54.2578 16.9531C54.2578 17.2188 54.3177 17.4609 54.4375 17.6797C54.5573 17.8984 54.737 18.0729 54.9766 18.2031C55.2214 18.3281 55.5208 18.3906 55.875 18.3906C56.3177 18.3906 56.7083 18.2969 57.0469 18.1094C57.3854 17.9219 57.6536 17.6927 57.8516 17.4219C58.0547 17.151 58.1641 16.888 58.1797 16.6328L58.7969 17.3281C58.7604 17.5469 58.6615 17.7891 58.5 18.0547C58.3385 18.3203 58.1224 18.5755 57.8516 18.8203C57.5859 19.0599 57.2682 19.2604 56.8984 19.4219C56.5339 19.5781 56.1224 19.6562 55.6641 19.6562C55.0911 19.6562 54.5885 19.5443 54.1562 19.3203C53.7292 19.0964 53.3958 18.7969 53.1562 18.4219C52.9219 18.0417 52.8047 17.6172 52.8047 17.1484C52.8047 16.6953 52.8932 16.2969 53.0703 15.9531C53.2474 15.6042 53.5026 15.3151 53.8359 15.0859C54.1693 14.8516 54.5703 14.6745 55.0391 14.5547C55.5078 14.4349 56.0312 14.375 56.6094 14.375H58.2891ZM61.8828 19.5V11.0469H63.3281V18.3125H67.2188V11.0469H68.6719V19.5H61.8828ZM69.6719 18.3125L69.5312 22.0078H68.2422V19.5H67.1406V18.3125H69.6719ZM72.8047 17.2109L76.7031 11.0469H78.1562V19.5H76.7031V13.3359L72.8047 19.5H71.3672V11.0469H72.8047V17.2109ZM80.0938 15.3672V15.1875C80.0938 14.5781 80.1823 14.013 80.3594 13.4922C80.5365 12.9661 80.7917 12.5104 81.125 12.125C81.4583 11.7344 81.862 11.4323 82.3359 11.2188C82.8099 11 83.3411 10.8906 83.9297 10.8906C84.5234 10.8906 85.0573 11 85.5312 11.2188C86.0104 11.4323 86.4167 11.7344 86.75 12.125C87.0885 12.5104 87.3464 12.9661 87.5234 13.4922C87.7005 14.013 87.7891 14.5781 87.7891 15.1875V15.3672C87.7891 15.9766 87.7005 16.5417 87.5234 17.0625C87.3464 17.5833 87.0885 18.0391 86.75 18.4297C86.4167 18.8151 86.013 19.1172 85.5391 19.3359C85.0703 19.5495 84.5391 19.6562 83.9453 19.6562C83.3516 19.6562 82.8177 19.5495 82.3438 19.3359C81.8698 19.1172 81.4635 18.8151 81.125 18.4297C80.7917 18.0391 80.5365 17.5833 80.3594 17.0625C80.1823 16.5417 80.0938 15.9766 80.0938 15.3672ZM81.5391 15.1875V15.3672C81.5391 15.7891 81.5885 16.1875 81.6875 16.5625C81.7865 16.9323 81.9349 17.2604 82.1328 17.5469C82.3359 17.8333 82.5885 18.0599 82.8906 18.2266C83.1927 18.388 83.5443 18.4688 83.9453 18.4688C84.3411 18.4688 84.6875 18.388 84.9844 18.2266C85.2865 18.0599 85.5365 17.8333 85.7344 17.5469C85.9323 17.2604 86.0807 16.9323 86.1797 16.5625C86.2839 16.1875 86.3359 15.7891 86.3359 15.3672V15.1875C86.3359 14.7708 86.2839 14.3776 86.1797 14.0078C86.0807 13.6328 85.9297 13.3021 85.7266 13.0156C85.5286 12.724 85.2786 12.4948 84.9766 12.3281C84.6797 12.1615 84.3307 12.0781 83.9297 12.0781C83.5339 12.0781 83.1849 12.1615 82.8828 12.3281C82.5859 12.4948 82.3359 12.724 82.1328 13.0156C81.9349 13.3021 81.7865 13.6328 81.6875 14.0078C81.5885 14.3776 81.5391 14.7708 81.5391 15.1875ZM95.3359 14.7109V15.8828H90.8672V14.7109H95.3359ZM91.1719 11.0469V19.5H89.7266V11.0469H91.1719ZM96.5078 11.0469V19.5H95.0547V11.0469H96.5078ZM103.82 18.0547V13.7031C103.82 13.3698 103.753 13.0807 103.617 12.8359C103.487 12.5859 103.289 12.3932 103.023 12.2578C102.758 12.1224 102.43 12.0547 102.039 12.0547C101.674 12.0547 101.354 12.1172 101.078 12.2422C100.807 12.3672 100.594 12.5312 100.438 12.7344C100.286 12.9375 100.211 13.1562 100.211 13.3906H98.7656C98.7656 13.0885 98.8438 12.7891 99 12.4922C99.1562 12.1953 99.3802 11.9271 99.6719 11.6875C99.9688 11.4427 100.323 11.25 100.734 11.1094C101.151 10.9635 101.615 10.8906 102.125 10.8906C102.74 10.8906 103.281 10.9948 103.75 11.2031C104.224 11.4115 104.594 11.7266 104.859 12.1484C105.13 12.5651 105.266 13.0885 105.266 13.7188V17.6562C105.266 17.9375 105.289 18.237 105.336 18.5547C105.388 18.8724 105.464 19.1458 105.562 19.375V19.5H104.055C103.982 19.3333 103.924 19.112 103.883 18.8359C103.841 18.5547 103.82 18.2943 103.82 18.0547ZM104.07 14.375L104.086 15.3906H102.625C102.214 15.3906 101.846 15.4245 101.523 15.4922C101.201 15.5547 100.93 15.651 100.711 15.7812C100.492 15.9115 100.326 16.0755 100.211 16.2734C100.096 16.4661 100.039 16.6927 100.039 16.9531C100.039 17.2188 100.099 17.4609 100.219 17.6797C100.339 17.8984 100.518 18.0729 100.758 18.2031C101.003 18.3281 101.302 18.3906 101.656 18.3906C102.099 18.3906 102.49 18.2969 102.828 18.1094C103.167 17.9219 103.435 17.6927 103.633 17.4219C103.836 17.151 103.945 16.888 103.961 16.6328L104.578 17.3281C104.542 17.5469 104.443 17.7891 104.281 18.0547C104.12 18.3203 103.904 18.5755 103.633 18.8203C103.367 19.0599 103.049 19.2604 102.68 19.4219C102.315 19.5781 101.904 19.6562 101.445 19.6562C100.872 19.6562 100.37 19.5443 99.9375 19.3203C99.5104 19.0964 99.1771 18.7969 98.9375 18.4219C98.7031 18.0417 98.5859 17.6172 98.5859 17.1484C98.5859 16.6953 98.6745 16.2969 98.8516 15.9531C99.0286 15.6042 99.2839 15.3151 99.6172 15.0859C99.9505 14.8516 100.352 14.6745 100.82 14.5547C101.289 14.4349 101.812 14.375 102.391 14.375H104.07ZM108.984 12.6719V22.75H107.531V11.0469H108.859L108.984 12.6719ZM114.68 15.2031V15.3672C114.68 15.9818 114.607 16.5521 114.461 17.0781C114.315 17.599 114.102 18.0521 113.82 18.4375C113.544 18.8229 113.203 19.1224 112.797 19.3359C112.391 19.5495 111.924 19.6562 111.398 19.6562C110.862 19.6562 110.388 19.5677 109.977 19.3906C109.565 19.2135 109.216 18.9557 108.93 18.6172C108.643 18.2786 108.414 17.8724 108.242 17.3984C108.076 16.9245 107.961 16.3906 107.898 15.7969V14.9219C107.961 14.2969 108.078 13.737 108.25 13.2422C108.422 12.7474 108.648 12.3255 108.93 11.9766C109.216 11.6224 109.562 11.3542 109.969 11.1719C110.375 10.9844 110.844 10.8906 111.375 10.8906C111.906 10.8906 112.378 10.9948 112.789 11.2031C113.201 11.4062 113.547 11.6979 113.828 12.0781C114.109 12.4583 114.32 12.9141 114.461 13.4453C114.607 13.9714 114.68 14.5573 114.68 15.2031ZM113.227 15.3672V15.2031C113.227 14.7812 113.182 14.3854 113.094 14.0156C113.005 13.6406 112.867 13.3125 112.68 13.0312C112.497 12.7448 112.263 12.5208 111.977 12.3594C111.69 12.1927 111.349 12.1094 110.953 12.1094C110.589 12.1094 110.271 12.1719 110 12.2969C109.734 12.4219 109.508 12.5911 109.32 12.8047C109.133 13.013 108.979 13.2526 108.859 13.5234C108.745 13.7891 108.659 14.0651 108.602 14.3516V16.375C108.706 16.7396 108.852 17.0833 109.039 17.4062C109.227 17.724 109.477 17.9818 109.789 18.1797C110.102 18.3724 110.495 18.4688 110.969 18.4688C111.359 18.4688 111.695 18.388 111.977 18.2266C112.263 18.0599 112.497 17.8333 112.68 17.5469C112.867 17.2604 113.005 16.9323 113.094 16.5625C113.182 16.1875 113.227 15.7891 113.227 15.3672ZM122.258 14.7109V15.8828H117.789V14.7109H122.258ZM118.094 11.0469V19.5H116.648V11.0469H118.094ZM123.43 11.0469V19.5H121.977V11.0469H123.43ZM126.945 13.9531H129.484C130.167 13.9531 130.742 14.0729 131.211 14.3125C131.68 14.5469 132.034 14.8724 132.273 15.2891C132.518 15.7005 132.641 16.1693 132.641 16.6953C132.641 17.0859 132.573 17.4531 132.438 17.7969C132.302 18.1354 132.099 18.4323 131.828 18.6875C131.562 18.9427 131.232 19.1432 130.836 19.2891C130.445 19.4297 129.995 19.5 129.484 19.5H125.891V11.0469H127.336V18.3125H129.484C129.901 18.3125 130.234 18.237 130.484 18.0859C130.734 17.9349 130.914 17.7396 131.023 17.5C131.133 17.2604 131.188 17.0104 131.188 16.75C131.188 16.4948 131.133 16.2448 131.023 16C130.914 15.7552 130.734 15.5521 130.484 15.3906C130.234 15.224 129.901 15.1406 129.484 15.1406H126.945V13.9531ZM135.648 11.0469V19.5H134.203V11.0469H135.648ZM139.742 17.2109L143.641 11.0469H145.094V19.5H143.641V13.3359L139.742 19.5H138.305V11.0469H139.742V17.2109ZM142.852 7.98438H144.023C144.023 8.39062 143.93 8.7526 143.742 9.07031C143.555 9.38281 143.286 9.6276 142.938 9.80469C142.589 9.98177 142.174 10.0703 141.695 10.0703C140.971 10.0703 140.398 9.8776 139.977 9.49219C139.56 9.10156 139.352 8.59896 139.352 7.98438H140.523C140.523 8.29167 140.612 8.5625 140.789 8.79688C140.966 9.03125 141.268 9.14844 141.695 9.14844C142.112 9.14844 142.409 9.03125 142.586 8.79688C142.763 8.5625 142.852 8.29167 142.852 7.98438Z"
      fill="#007E3C"
    />
  </svg>
);

export const Humidity = ({ fill = 'transparent' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7376 11.2332C13.7376 13.9245 11.6165 16.1062 9.00003 16.1062C6.38354 16.1062 4.26245 13.9245 4.26245 11.2332C4.26245 6.86789 9.00003 1.89343 9.00003 1.89343C9.00003 1.89343 13.7376 6.86789 13.7376 11.2332Z"
      fill={fill}
    />
    <path
      d="M11.7072 11.1317C11.7072 12.7016 10.4952 13.9743 9.00003 13.9743M13.7376 11.2332C13.7376 13.9245 11.6165 16.1062 9.00003 16.1062C6.38354 16.1062 4.26245 13.9245 4.26245 11.2332C4.26245 6.86789 9.00003 1.89343 9.00003 1.89343C9.00003 1.89343 13.7376 6.86789 13.7376 11.2332Z"
      stroke="#292E3A"
      strokeWidth="0.789596"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Gluten = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.10849 2.70468C3.80163 3.00962 3.33309 3.84346 3.91381 4.73937L4.44614 5.56061C4.69736 5.89257 5.45773 6.5208 6.36559 6.18679M6.36559 6.18679C6.22699 6.3812 6.10798 6.54571 6.02303 6.65903C5.65197 7.15402 5.78504 7.62617 5.89796 7.80038L6.67226 8.99492M6.36559 6.18679C6.83238 5.53204 7.52129 4.53817 7.87913 4.01854M6.80605 4.03092L7.48411 3.90949C7.68476 3.88545 7.71292 3.93144 7.87913 4.01854M6.67226 8.99492L7.01101 9.51753C7.19319 9.74432 7.68361 10.1079 8.21652 9.79517M6.67226 8.99492C6.8676 8.72236 7.34201 8.09177 7.65079 7.66915M7.87913 4.01854C8.05909 4.11283 8.26434 4.27923 8.44547 4.55867L8.92941 5.30525C9.01006 5.42969 9.06339 5.81217 8.63142 6.34663C8.37783 6.6604 8.08979 7.06831 7.65079 7.66915M8.21652 9.79517C8.22973 9.78742 8.24296 9.77926 8.25621 9.77067M8.21652 9.79517C8.18515 9.838 8.15648 9.87678 8.13089 9.91091C7.75983 10.4059 7.8929 10.8781 8.00582 11.0523L8.78012 12.2468M8.21652 9.79517C8.6401 9.21677 9.55491 7.89787 9.987 7.27041M7.65079 7.66915L9.987 7.27041M9.987 7.27041C10.1876 7.24638 10.3722 7.5311 10.5533 7.81055L11.0373 8.55713C11.1179 8.68157 11.1713 9.06404 10.7393 9.59851C10.5224 9.86686 10.1487 10.3669 9.7704 10.882M8.78012 12.2468L9.11888 12.7694C9.29039 12.9829 9.73512 13.3176 10.2313 13.0952M8.78012 12.2468C8.97547 11.9742 9.26989 11.5663 9.57867 11.1437C9.64222 11.0567 9.70638 10.9691 9.7704 10.882M10.2313 13.0952C10.2752 13.0755 10.3195 13.0514 10.3641 13.0225M10.2313 13.0952C10.2246 13.1041 10.2181 13.1128 10.2118 13.1212C9.84076 13.6162 9.97383 14.0884 10.0868 14.2626L10.8611 15.4571M10.2313 13.0952C10.6174 12.5765 11.6117 11.1432 12.0679 10.4807M10.8611 15.4571L11.1998 15.9797C11.3865 16.2122 11.8969 16.5882 12.445 16.2329M10.8611 15.4571C11.0564 15.1846 11.3508 14.7767 11.6596 14.3541C12.0986 13.7532 12.5666 13.1226 12.8202 12.8088C13.2522 12.2744 13.1989 11.8919 13.1182 11.7675L12.6343 11.0209C12.4531 10.7414 12.2686 10.4567 12.0679 10.4807M12.0679 10.4807L9.7704 10.882"
      stroke="#292E3A"
      strokeWidth="0.631677"
      strokeLinecap="round"
    />
  </svg>
);

export const Temperature = ({ fill = 'transparent' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1008 10.0715C11.9815 10.7193 12.5531 11.7638 12.5531 12.9421C12.5531 14.9077 10.9623 16.5011 8.99996 16.5011C7.03759 16.5011 5.44678 14.9077 5.44678 12.9421C5.44678 11.7638 6.01846 10.7193 6.89916 10.0715M11.1319 10.0715V3.64197C11.1319 2.45832 10.1774 1.49878 8.99996 1.49878C7.82254 1.49878 6.86805 2.45832 6.86805 3.64197V10.0715"
      stroke="#292E3A"
      strokeWidth="0.789596"
      strokeLinecap="round"
    />
    <path
      d="M11.1317 12.9289C11.1317 14.1125 10.1773 15.0721 8.99983 15.0721C7.82241 15.0721 6.86792 14.1125 6.86792 12.9289C6.86792 11.7452 7.82241 10.7857 8.99983 10.7857C10.1773 10.7857 11.1317 11.7452 11.1317 12.9289Z"
      fill={fill}
    />
    <path
      d="M8.28919 4.35612C8.28919 3.96157 8.60736 3.64172 8.99983 3.64172C9.3923 3.64172 9.71047 3.96157 9.71047 4.35612V10.7857C9.71047 11.1802 9.3923 11.5001 8.99983 11.5001C8.60736 11.5001 8.28919 11.1802 8.28919 10.7857V4.35612Z"
      fill={fill}
    />
  </svg>
);

export const Weight = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1877 4.12481C11.2733 3.68551 11.2 3.22979 10.9811 2.84045C10.7622 2.45111 10.4122 2.15399 9.99474 2.00309C9.57729 1.8522 9.12008 1.85753 8.70619 2.01813C8.29231 2.17873 7.94922 2.48393 7.73927 2.87828C7.52932 3.27263 7.46645 3.72994 7.56208 4.16712C7.65771 4.6043 7.9055 4.99232 8.26041 5.26069C8.61533 5.52905 9.05381 5.65994 9.49618 5.62956M4.16554 16.1064H13.8347C14.778 16.1064 15.4811 15.2282 15.2834 14.2969L13.696 6.81648C13.5496 6.12668 12.9459 5.63387 12.2472 5.63387H5.753C5.05436 5.63387 4.45065 6.12668 4.30426 6.81648L2.7168 14.2969C2.51916 15.2282 3.22227 16.1064 4.16554 16.1064Z"
      stroke="#292E3A"
      strokeWidth="0.789596"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.59078 12.956C8.59078 13.0433 8.66148 13.114 8.7487 13.114H9.21172C9.29894 13.114 9.36964 13.0433 9.36964 12.956V9.48533C9.36964 9.39812 9.44035 9.32741 9.52756 9.32741H10.0118C10.1009 9.32741 10.1426 9.37799 10.1426 9.46649V9.58039C10.1426 9.66761 10.2133 9.73831 10.3005 9.73831H10.6743C10.7615 9.73831 10.8322 9.66761 10.8322 9.58039V9.03031C10.8322 8.7332 10.7312 8.62573 10.4517 8.62573H7.50274C7.2233 8.62573 7.12817 8.7332 7.12817 9.03031V9.58039C7.12817 9.66761 7.19888 9.73831 7.28609 9.73831H7.65399C7.74121 9.73831 7.81191 9.66761 7.81191 9.58039V9.46649C7.81191 9.37799 7.85353 9.32741 7.94271 9.32741H8.43286C8.52007 9.32741 8.59078 9.39812 8.59078 9.48533V12.956Z"
      fill="#292E3A"
    />
  </svg>
);

export const Attention = () => (
  <svg
    width="23"
    height="21"
    viewBox="0 0 23 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.61517 2.1011C9.89684 -0.0337002 13.1032 -0.0337008 14.3848 2.1011L22.5494 15.7002C23.8303 17.8339 22.2279 20.5 19.6645 20.5H3.33547C0.77212 20.5 -0.830327 17.8339 0.450634 15.7002L8.61517 2.1011Z"
      fill="#F1898E"
    />
    <path
      d="M11.5001 5.5C12.2102 5.5 12.7858 6.0233 12.7858 6.66883V12.513C12.7858 13.1585 12.2102 13.6818 11.5001 13.6818C10.79 13.6818 10.2144 13.1585 10.2144 12.513V6.66883C10.2144 6.0233 10.79 5.5 11.5001 5.5Z"
      fill="white"
    />
    <path
      d="M11.5001 17.5C12.2102 17.5 12.7858 16.9244 12.7858 16.2143C12.7858 15.5042 12.2102 14.9286 11.5001 14.9286C10.79 14.9286 10.2144 15.5042 10.2144 16.2143C10.2144 16.9244 10.79 17.5 11.5001 17.5Z"
      fill="white"
    />
  </svg>
);

export const ZoomIcon = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_197_3448)">
      <rect width="46" height="46" rx="8" fill="#66B28A" />
      <g clipPath="url(#clip1_197_3448)">
        <path
          d="M37.5568 7.81751C38.6585 8.40898 39.6676 9.15877 40.5517 10.043L58.8711 28.3623C60.0467 29.5379 60.0467 31.4441 58.8711 32.6198C57.6954 33.7954 55.7892 33.7954 54.6136 32.6198L36.2943 14.3004C35.4101 13.4163 34.6603 12.4072 34.0688 11.3055L32.1451 7.72246C31.8633 7.19756 31.9588 6.55001 32.38 6.12874C32.8013 5.70747 33.4489 5.61203 33.9738 5.89383L37.5568 7.81751Z"
          fill="#EBD8A8"
        />
      </g>
      <g clipPath="url(#clip2_197_3448)">
        <path
          d="M31.2439 14.1303C32.3455 14.7217 33.3546 15.4715 34.2388 16.3557L52.5581 34.675C53.7337 35.8507 53.7337 37.7568 52.5581 38.9325C51.3824 40.1082 49.4763 40.1082 48.3006 38.9325L29.9813 20.6132C29.0971 19.729 28.3473 18.72 27.7558 17.6183L25.8322 14.0352C25.5503 13.5103 25.6458 12.8628 26.0671 12.4415C26.4883 12.0202 27.1359 11.9248 27.6608 12.2066L31.2439 14.1303Z"
          fill="#EBD8A8"
        />
      </g>
      <g clipPath="url(#clip3_197_3448)">
        <path
          d="M24.9314 20.4429C26.033 21.0344 27.0421 21.7841 27.9263 22.6683L46.2456 40.9876C47.4212 42.1633 47.4212 44.0694 46.2456 45.2451C45.0699 46.4208 43.1638 46.4208 41.9881 45.2451L23.6688 26.9258C22.7846 26.0416 22.0348 25.0326 21.4433 23.9309L19.5197 20.3478C19.2378 19.8229 19.3333 19.1754 19.7546 18.7541C20.1758 18.3328 20.8234 18.2374 21.3483 18.5192L24.9314 20.4429Z"
          fill="#EBD8A8"
        />
      </g>
      <g clipPath="url(#clip4_197_3448)">
        <path
          d="M18.6184 26.7556C19.7201 27.3471 20.7291 28.0969 21.6133 28.9811L39.9326 47.3004C41.1083 48.4761 41.1083 50.3822 39.9326 51.5579C38.7569 52.7335 36.8508 52.7335 35.6751 51.5579L17.3558 33.2385C16.4716 32.3544 15.7218 31.3453 15.1303 30.2436L13.2067 26.6606C12.9249 26.1357 13.0203 25.4881 13.4416 25.0669C13.8628 24.6456 14.5104 24.5501 15.0353 24.8319L18.6184 26.7556Z"
          fill="#C2E580"
        />
      </g>
      <g clipPath="url(#clip5_197_3448)">
        <path
          d="M12.3054 33.0682C13.4071 33.6597 14.4161 34.4095 15.3003 35.2937L33.6196 53.613C34.7953 54.7887 34.7953 56.6948 33.6196 57.8705C32.4439 59.0462 30.5378 59.0462 29.3621 57.8705L11.0428 39.5512C10.1586 38.667 9.40882 37.658 8.81735 36.5563L6.89367 32.9732C6.61187 32.4483 6.70732 31.8007 7.12858 31.3795C7.54985 30.9582 8.1974 30.8628 8.7223 31.1446L12.3054 33.0682Z"
          fill="#EEB9C2"
        />
      </g>
      <g clipPath="url(#clip6_197_3448)">
        <path
          d="M6.55684 -23.1825C7.65853 -22.591 8.66756 -21.8412 9.55174 -20.957L27.8711 -2.63773C29.0467 -1.46206 29.0467 0.444081 27.8711 1.61975C26.6954 2.79542 24.7892 2.79542 23.6136 1.61975L5.29426 -16.6996C4.41007 -17.5837 3.66029 -18.5928 3.06882 -19.6945L1.14514 -23.2775C0.863333 -23.8024 0.95878 -24.45 1.38005 -24.8713C1.80131 -25.2925 2.44886 -25.388 2.97376 -25.1062L6.55684 -23.1825Z"
          fill="#C2E580"
        />
      </g>
      <g clipPath="url(#clip7_197_3448)">
        <path
          d="M0.243852 -16.8697C1.34554 -16.2783 2.35457 -15.5285 3.23875 -14.6443L21.5581 3.67501C22.7337 4.85069 22.7337 6.75682 21.5581 7.9325C20.3824 9.10817 18.4763 9.10817 17.3006 7.9325L-1.01873 -10.3868C-1.90291 -11.271 -2.6527 -12.28 -3.24417 -13.3817L-5.16785 -16.9648C-5.44966 -17.4897 -5.35421 -18.1372 -4.93294 -18.5585C-4.51167 -18.9798 -3.86412 -19.0752 -3.33923 -18.7934L0.243852 -16.8697Z"
          fill="#C2E580"
        />
      </g>
      <g clipPath="url(#clip8_197_3448)">
        <path
          d="M-6.06865 -10.5571C-4.96696 -9.96565 -3.95793 -9.21586 -3.07375 -8.33168L15.2456 9.98764C16.4212 11.1633 16.4212 13.0694 15.2456 14.2451C14.0699 15.4208 12.1638 15.4208 10.9881 14.2451L-7.33123 -4.0742C-8.21541 -4.95838 -8.9652 -5.96741 -9.55667 -7.0691L-11.4803 -10.6522C-11.7622 -11.1771 -11.6667 -11.8246 -11.2454 -12.2459C-10.8242 -12.6672 -10.1766 -12.7626 -9.65173 -12.4808L-6.06865 -10.5571Z"
          fill="#EEB9C2"
        />
      </g>
      <g clipPath="url(#clip9_197_3448)">
        <path
          d="M-12.3816 -4.24438C-11.2799 -3.65291 -10.2709 -2.90312 -9.38673 -2.01894L8.93258 16.3004C10.1083 17.4761 10.1083 19.3822 8.93258 20.5579C7.75691 21.7335 5.85077 21.7335 4.6751 20.5579L-13.6442 2.23854C-14.5284 1.35436 -15.2782 0.345334 -15.8697 -0.756356L-17.7933 -4.33943C-18.0751 -4.86433 -17.9797 -5.51188 -17.5584 -5.93315C-17.1372 -6.35442 -16.4896 -6.44986 -15.9647 -6.16806L-12.3816 -4.24438Z"
          fill="#EEB9C2"
        />
      </g>
      <g clipPath="url(#clip10_197_3448)">
        <path
          d="M-18.6946 2.06824C-17.5929 2.65972 -16.5839 3.4095 -15.6997 4.29369L2.61959 22.613C3.79526 23.7887 3.79526 25.6948 2.61959 26.8705C1.44392 28.0462 -0.462219 28.0462 -1.63789 26.8705L-19.9572 8.55117C-20.8414 7.66698 -21.5912 6.65796 -22.1826 5.55627L-24.1063 1.97319C-24.3881 1.44829 -24.2927 0.800741 -23.8714 0.379474C-23.4501 -0.0417936 -22.8026 -0.13724 -22.2777 0.144566L-18.6946 2.06824Z"
          fill="#EEB9C2"
        />
      </g>
    </g>
    <rect x="1" y="1" width="44" height="44" rx="7" stroke="white" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_197_3448">
        <rect width="46" height="46" rx="8" fill="white" />
      </clipPath>
      <clipPath id="clip1_197_3448">
        <rect
          width="37.4639"
          height="6.02099"
          fill="white"
          transform="translate(34.5088 4) rotate(45)"
        />
      </clipPath>
      <clipPath id="clip2_197_3448">
        <rect
          width="37.4639"
          height="6.02099"
          fill="white"
          transform="translate(28.1958 10.3127) rotate(45)"
        />
      </clipPath>
      <clipPath id="clip3_197_3448">
        <rect
          width="37.4639"
          height="6.02099"
          fill="white"
          transform="translate(21.8833 16.6254) rotate(45)"
        />
      </clipPath>
      <clipPath id="clip4_197_3448">
        <rect
          width="37.4639"
          height="6.02099"
          fill="white"
          transform="translate(15.5703 22.9381) rotate(45)"
        />
      </clipPath>
      <clipPath id="clip5_197_3448">
        <rect
          width="37.4639"
          height="6.02099"
          fill="white"
          transform="translate(9.25732 29.2507) rotate(45)"
        />
      </clipPath>
      <clipPath id="clip6_197_3448">
        <rect
          width="37.4639"
          height="6.02099"
          fill="white"
          transform="translate(3.50879 -27) rotate(45)"
        />
      </clipPath>
      <clipPath id="clip7_197_3448">
        <rect
          width="37.4639"
          height="6.02099"
          fill="white"
          transform="translate(-2.8042 -20.6873) rotate(45)"
        />
      </clipPath>
      <clipPath id="clip8_197_3448">
        <rect
          width="37.4639"
          height="6.02099"
          fill="white"
          transform="translate(-9.1167 -14.3746) rotate(45)"
        />
      </clipPath>
      <clipPath id="clip9_197_3448">
        <rect
          width="37.4639"
          height="6.02099"
          fill="white"
          transform="translate(-15.4297 -8.06189) rotate(45)"
        />
      </clipPath>
      <clipPath id="clip10_197_3448">
        <rect
          width="37.4639"
          height="6.02099"
          fill="white"
          transform="translate(-21.7427 -1.74927) rotate(45)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const LogoLarge = () => (
  <svg
    width="167"
    height="40"
    viewBox="0 0 167 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.5966 28.3917C38.4587 28.024 38.327 27.6523 38.1808 27.2866C37.8638 26.4761 37.4892 25.6879 37.057 24.9302C36.6762 24.2802 36.2583 23.6545 35.8055 23.0532C35.0851 22.1005 34.272 21.2189 33.3808 20.4206C33.1255 20.1809 32.8394 19.9879 32.5636 19.7766C32.2384 19.5369 31.9132 19.2972 31.5797 19.0575C31.2051 18.7873 30.8099 18.5476 30.3962 18.3384C30.1533 18.2165 29.9104 18.0682 29.649 17.9321C29.0727 17.6396 28.4799 17.3796 27.8727 17.1561C27.0061 16.821 26.1148 16.5548 25.205 16.3619C24.5526 16.1994 23.8836 16.1059 23.2105 16.0836C23.1838 16.0876 23.1591 16.0876 23.1323 16.0836C22.4633 15.9617 21.782 15.9089 21.1028 15.9272C20.9978 15.9272 20.8908 15.9007 20.792 16.0206C20.8105 16.433 20.8681 16.8433 20.9608 17.2455C21.0698 17.7249 21.2036 18.1881 21.3374 18.6512C21.465 19.0656 21.6112 19.478 21.7779 19.8762C22.0393 20.5018 22.3028 21.1275 22.6095 21.7288C22.9923 22.454 23.4246 23.1507 23.9062 23.813C24.4496 24.5707 25.0527 25.2837 25.7093 25.9479C26.2733 26.5086 26.8682 27.0368 27.4898 27.5324C28.0497 27.9692 28.6384 28.3673 29.2517 28.7289C29.5996 28.9463 29.9578 29.1555 30.32 29.3485C30.5629 29.4744 30.8058 29.5679 31.0487 29.6755C31.3657 29.8116 31.6826 29.9558 32.0037 30.0757C32.7036 30.3438 33.4199 30.5693 34.1485 30.7501C34.9883 30.9573 35.8425 31.1056 36.7029 31.197C36.7853 31.2092 36.8655 31.2255 36.9458 31.2498C36.9458 31.3148 36.9458 31.3616 36.9273 31.388C36.1986 32.3326 35.472 33.3036 34.5705 34.1364C34.4223 34.043 34.2803 33.9414 34.1465 33.8317C33.6298 33.3706 33.0803 32.946 32.5039 32.5601C32.2405 32.3813 31.9626 32.2229 31.6765 32.0807C31.203 31.8247 30.7337 31.5586 30.248 31.3291C29.612 31.0162 28.9533 30.7542 28.2761 30.5409C27.8418 30.4109 27.4095 30.2687 26.9711 30.1671C26.0428 29.9315 25.098 29.771 24.1429 29.6877C23.4308 29.6369 22.7186 29.6227 21.9776 29.6085C21.9549 29.6999 21.9014 29.7913 21.9179 29.8482C22.0393 30.3032 22.0723 30.7745 22.2122 31.2336C22.3357 31.646 22.4036 32.0807 22.5436 32.493C22.7515 33.1086 22.982 33.718 23.2455 34.3192C23.4452 34.7743 23.6592 35.2212 23.8898 35.66C24.1327 36.1089 24.4002 36.5456 24.6905 36.9661C24.9807 37.4008 25.2997 37.8153 25.6188 38.2276C25.839 38.51 26.0819 38.772 26.3474 39.0686C23.4658 40.0254 20.5264 40.1574 17.5254 39.8568C12.3198 39.0666 7.96852 36.7447 4.61548 32.7246C1.21305 28.6273 -0.334823 23.8597 0.0603783 18.5456C0.455579 13.2315 2.71152 8.76858 6.69029 5.16695C8.50986 3.51137 10.632 2.21129 12.9435 1.33577C17.795 -0.498566 23.1714 -0.441687 27.9817 1.49422C30.3715 2.45099 32.5471 3.86077 34.3832 5.64838C36.7523 7.91134 38.5225 10.7146 39.5373 13.8105C41.1119 18.6086 40.8011 23.815 38.6666 28.3978C38.6439 28.3978 38.6192 28.3978 38.5966 28.3897V28.3917ZM38.0203 17.5766C38.0306 17.4568 38.0306 17.3349 38.0203 17.215C37.9091 16.6503 37.7938 16.0876 37.6642 15.5392C37.5901 15.2243 37.4995 14.9155 37.3904 14.6108C37.1969 14.0705 36.9993 13.5261 36.777 12.9979C36.5897 12.551 36.3674 12.1163 36.1513 11.6836C36.0216 11.4053 35.8734 11.1351 35.7067 10.8771C35.33 10.3266 34.9286 9.79849 34.5499 9.25205C34.0868 8.61419 33.564 8.02103 32.9897 7.47865C32.5266 7.01753 32.0346 6.58485 31.52 6.1806C31.0343 5.80683 30.5506 5.4615 30.0504 5.12226C29.8734 4.99834 29.6922 4.88459 29.5029 4.77895C29.3135 4.66926 29.1138 4.57582 28.9204 4.47425C28.5787 4.29549 28.239 4.1025 27.8871 3.94203C27.5351 3.78155 27.1584 3.6617 26.8188 3.49512C26.368 3.29808 25.9028 3.1376 25.4273 3.01572C24.8592 2.84305 24.2726 2.7232 23.6922 2.59522C23.3258 2.516 22.9635 2.4449 22.5868 2.40224C22.1237 2.34943 21.6544 2.32099 21.1892 2.30677C20.724 2.29255 20.2197 2.30677 19.6846 2.30677C19.6558 2.39005 19.6434 2.47537 19.6434 2.56272C19.6825 2.81461 19.7422 3.06041 19.7916 3.31027C19.8575 3.63529 19.8986 3.96843 19.9851 4.28736C20.2589 5.26852 20.6047 6.22936 21.0225 7.15973C21.2592 7.71023 21.5371 8.24042 21.8541 8.74827C22.2122 9.30893 22.5477 9.88584 22.9532 10.4242C23.4596 11.0823 24.0133 11.708 24.5793 12.3174C25.0651 12.8293 25.5941 13.3006 26.1601 13.7231C26.6788 14.1172 27.2346 14.4768 27.7697 14.8505C27.8871 14.9297 27.992 15.0273 28.1176 15.0902C28.521 15.3076 28.9245 15.529 29.33 15.726C29.8157 15.9657 30.2994 16.1851 30.8037 16.3842C31.4645 16.6422 32.1437 16.8453 32.8271 17.0403C32.9506 17.0729 33.07 17.1257 33.1955 17.15C33.6813 17.2435 34.165 17.3471 34.6508 17.4222C35.717 17.5827 36.7956 17.6457 37.8721 17.6112C37.9215 17.603 37.9709 17.5909 38.0182 17.5746L38.0203 17.5766Z"
      fill="#E73A42"
    />
    <path
      d="M140.37 34.2836C140.265 34.2836 140.164 34.312 140.059 34.312H134.232C134.214 34.2287 134.199 34.1434 134.191 34.0581V19.6597C134.205 19.4667 134.138 19.2758 134.002 19.1356C133.298 18.3149 132.596 17.4922 131.896 16.6675C131.544 16.2531 131.198 15.8387 130.85 15.4222C130.815 15.3694 130.782 15.3146 130.754 15.2577H148.888C151.491 15.2171 153.657 17.22 153.784 19.7877C153.799 20.0274 153.784 20.2671 153.784 20.5068V34.2572C153.48 34.314 148.155 34.3283 147.665 34.2734C147.649 34.1942 147.638 34.115 147.632 34.0337V20.9212C147.649 20.5982 147.562 20.2793 147.389 20.007C147.179 19.6434 146.794 19.4139 146.37 19.3956C146.267 19.3794 146.164 19.3712 146.062 19.3672H140.656C140.57 19.3672 140.481 19.3672 140.362 19.3834V33.5929C140.366 33.8225 140.366 34.052 140.366 34.2815L140.37 34.2836Z"
      fill="#007E3C"
    />
    <path
      d="M111.483 19.2281C111.073 18.7345 110.664 18.2368 110.246 17.7431C109.601 16.9773 108.945 16.2135 108.305 15.4477C108.27 15.401 108.237 15.3502 108.208 15.2994C108.358 15.2527 108.515 15.2385 108.671 15.2567H114.206C116.777 15.2567 119.348 15.2567 121.919 15.271C124.543 15.275 126.684 17.345 126.741 19.935V34.2643C126.636 34.2806 126.554 34.3009 126.467 34.309C126.414 34.3131 126.363 34.3131 126.309 34.309H111.964C110.579 34.3273 109.256 33.7362 108.358 32.6961C107.611 31.8937 107.187 30.8496 107.164 29.7608C107.148 29.0417 107.146 28.3246 107.164 27.6055C107.251 25.048 109.377 23.0186 111.969 23.0186H119.959C120.153 23.0186 120.344 23.0186 120.56 23.0003C120.56 22.9008 120.589 22.8135 120.589 22.7281C120.589 22.0862 120.589 21.4484 120.564 20.8126C120.579 20.2722 120.272 19.7725 119.78 19.5328C119.574 19.4129 119.335 19.3662 119.099 19.3987C118.959 19.3987 118.815 19.3804 118.675 19.3804H111.936C111.769 19.4007 111.6 19.3459 111.479 19.2301L111.483 19.2281ZM120.511 31.0243C120.589 30.6607 120.589 26.5593 120.511 26.1734H115.155C114.132 26.214 113.323 27.0469 113.325 28.0564C113.325 28.4505 113.306 28.8507 113.325 29.2529C113.341 29.9781 113.79 30.6241 114.469 30.9004C114.784 31.0243 115.122 31.0791 115.462 31.0609H120.142C120.266 31.0487 120.391 31.0304 120.509 31.0223L120.511 31.0243Z"
      fill="#007E3C"
    />
    <path
      d="M166.694 7.46843C166.752 8.4699 166.752 9.4734 166.694 10.4749C166.686 10.485 166.676 10.4932 166.666 10.4992C166.655 10.5074 166.643 10.5114 166.629 10.5135H92.2072C92.1599 10.5094 92.1146 10.4992 92.0693 10.485C92.0179 10.162 92.0055 9.83295 92.0302 9.5059V8.4699C92.0302 8.12457 92.0138 7.80767 92.0302 7.51312C92.0714 7.47046 92.0755 7.45827 92.0858 7.45015C92.0961 7.44202 92.1084 7.43796 92.1228 7.43593C92.1743 7.4278 92.2237 7.42171 92.2752 7.41968H166.548C166.598 7.43187 166.647 7.45015 166.694 7.47046V7.46843Z"
      fill="#007E3C"
    />
    <path
      d="M80.4464 5.86792H86.5946C86.5946 6.00605 86.6111 6.132 86.6111 6.25591V29.893C86.6008 30.086 86.6708 30.2729 86.8025 30.4151C87.4509 31.1667 88.091 31.9224 88.7312 32.6801C89.1408 33.1595 89.5463 33.6369 89.9435 34.1163C89.9703 34.1528 89.995 34.1894 90.0197 34.228C90.0032 34.2564 89.9971 34.2666 89.9888 34.2727C89.9785 34.2808 89.9662 34.2849 89.9518 34.2849H80.4793C80.4608 34.1995 80.4484 34.1142 80.4402 34.0269V6.50984C80.4443 6.3067 80.4443 6.10559 80.4443 5.86792H80.4464Z"
      fill="#007E3C"
    />
    <path
      d="M51.4272 5.86035H57.4911C57.4911 5.95379 57.5281 6.03708 57.5302 6.12037V30.1902C58.1127 30.8727 58.6911 31.5431 59.2612 32.2215C59.8314 32.9021 60.416 33.5602 60.9985 34.2875H51.4416L51.4025 34.2489C51.4025 34.2489 51.3901 34.2285 51.3881 34.2164C51.3881 34.1514 51.3757 34.0904 51.3757 34.0254V5.95786C51.384 5.94161 51.4025 5.91926 51.4272 5.86035Z"
      fill="#007E3C"
    />
    <path
      d="M72.6326 34.2949C72.4247 34.2949 72.2147 34.3111 72.011 34.3111H66.4946C66.4761 34.2238 66.4637 34.1344 66.4555 34.045V19.6994C66.4617 19.4841 66.3835 19.2728 66.2373 19.1123C65.2287 17.9402 64.2304 16.76 63.2301 15.5818C63.1601 15.4965 63.0942 15.4071 63.0345 15.3421C63.0407 15.3218 63.049 15.3015 63.0592 15.2832H72.6038C72.6038 15.4742 72.6326 15.6671 72.6346 15.8581V33.5169C72.6326 33.7606 72.6326 34.0267 72.6326 34.2949Z"
      fill="#007E3C"
    />
    <path
      d="M101.71 34.2855C101.609 34.2855 101.506 34.3099 101.401 34.3119H95.5697C95.5697 34.2144 95.5429 34.1129 95.5429 34.0174V19.8627C95.5532 19.556 95.4421 19.2594 95.2342 19.0319C94.2462 17.8923 93.2788 16.7385 92.3031 15.5887C92.2311 15.5034 92.1693 15.41 92.0808 15.2881H101.636C101.658 15.347 101.687 15.414 101.714 15.4851C101.714 15.6355 101.699 15.7919 101.699 15.9422V33.4181C101.708 33.6985 101.71 34.0032 101.71 34.2876V34.2855Z"
      fill="#007E3C"
    />
    <path
      d="M157.123 15.2713H166.707C166.719 15.3668 166.731 15.4541 166.735 15.5395C166.739 15.6248 166.735 15.6918 166.735 15.7792V34.2403L166.684 34.285C166.684 34.285 166.661 34.3074 166.653 34.3074L160.811 34.3195C160.748 34.3195 160.686 34.3196 160.597 34.3053C160.583 34.218 160.575 34.1306 160.571 34.0413V19.5819C160.575 19.4296 160.515 19.2813 160.408 19.1695C159.36 17.9446 158.317 16.7197 157.279 15.4927C157.236 15.4379 157.195 15.3729 157.121 15.2693L157.123 15.2713Z"
      fill="#007E3C"
    />
    <path
      d="M72.6084 10.5135H63.0001C62.9487 10.1864 62.9363 9.85531 62.961 9.5242V7.49485C63.1133 7.43188 63.2821 7.40954 63.4468 7.43594H72.205C72.3306 7.43594 72.4479 7.43594 72.6084 7.45219C72.6208 8.4821 72.6064 9.47545 72.6084 10.5135Z"
      fill="#007E3C"
    />
  </svg>
);

export const ManageGrainWarehouse = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="8" fill="#E1F3EA" />
    <g clipPath="url(#clip0_1011_3102)">
      <path
        d="M20.5483 31.1183C17.9293 31.4693 15.785 33.4933 15.0494 36.1779L6 30.7841L7.15555 29.1278C8.84397 26.7096 12.0369 26.0093 14.5345 27.5077L20.5483 31.1183Z"
        fill="#66B28A"
      />
      <path
        d="M21.3612 37.2537H25.8611C25.8611 34.9201 23.846 33.0293 21.3612 33.0293C18.8756 33.0293 16.8613 34.921 16.8613 37.2537H21.3612Z"
        fill="#66B28A"
      />
      <path
        d="M27.9643 23.1271C25.3453 23.4781 23.201 25.5021 22.4654 28.1867L13.416 22.7929L14.5716 21.1366C16.26 18.7184 19.4529 18.0181 21.9505 19.5165L27.9643 23.1271Z"
        fill="#66B28A"
      />
      <path
        d="M28.7772 29.2635H33.2771C33.2771 26.9299 31.262 25.0391 28.7772 25.0391C26.2916 25.0391 24.2773 26.9308 24.2773 29.2635H28.7772Z"
        fill="#66B28A"
      />
      <path
        d="M36.687 15.9357C34.068 16.2867 31.9236 18.3107 31.1881 20.9953L22.1387 15.6015L23.2942 13.9452C24.9826 11.527 28.1756 10.8267 30.6732 12.3251L36.687 15.9357Z"
        fill="#66B28A"
      />
      <path
        d="M37.4999 22.0701H41.9998C41.9998 19.7366 39.9846 17.8457 37.4999 17.8457C35.0143 17.8457 33 19.7374 33 22.0701H37.4999Z"
        fill="#66B28A"
      />
    </g>
    <defs>
      <clipPath id="clip0_1011_3102">
        <rect
          width="36"
          height="25.7143"
          fill="white"
          transform="translate(6 11.5391)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const AnaliticalMixing = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="8" fill="#E1F3EA" />
    <path
      d="M13 27H11C9.89543 27 9 27.8954 9 29V38C9 39.1046 9.89543 40 11 40H13C14.1046 40 15 39.1046 15 38V29C15 27.8954 14.1046 27 13 27Z"
      fill="#66B28A"
    />
    <path
      d="M21 22H19C17.8954 22 17 22.8954 17 24V38C17 39.1046 17.8954 40 19 40H21C22.1046 40 23 39.1046 23 38V24C23 22.8954 22.1046 22 21 22Z"
      fill="#66B28A"
    />
    <path
      d="M29 30H27C25.8954 30 25 30.8954 25 32V38C25 39.1046 25.8954 40 27 40H29C30.1046 40 31 39.1046 31 38V32C31 30.8954 30.1046 30 29 30Z"
      fill="#66B28A"
    />
    <path
      d="M37 25H35C33.8954 25 33 25.8954 33 27V38C33 39.1046 33.8954 40 35 40H37C38.1046 40 39 39.1046 39 38V27C39 25.8954 38.1046 25 37 25Z"
      fill="#66B28A"
    />
    <path
      d="M10.5 22L16.7149 14.8187C18.4028 12.8683 21.4682 13.0018 22.9802 15.0915L25.2281 18.1982C26.6712 20.1927 29.5563 20.4226 31.2971 18.6818L38.4789 11.5"
      stroke="#66B28A"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const GrainMixCalc = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="8" fill="#E1F3EA" />
    <g clipPath="url(#clip0_5765_3828)">
      <path
        d="M23.3398 11H13.2851C12.0251 11 11 12.0252 11 13.2852V23.3398H23.3398V11Z"
        fill="#66B28A"
        stroke="#E1F3EA"
        strokeWidth="0.999997"
      />
      <path
        d="M35.6797 23.3398V13.2852C35.6797 12.0252 34.6545 11 33.3945 11H23.3398V23.3398H35.6797Z"
        fill="#66B28A"
        stroke="#E1F3EA"
        strokeWidth="0.999997"
      />
      <path
        d="M23.3398 23.3399V35.6797H28.3164C28.5184 35.6797 28.7122 35.5994 28.855 35.4566L35.4565 28.855C35.5273 28.7843 35.5834 28.7003 35.6217 28.6079C35.6599 28.5155 35.6797 28.4165 35.6797 28.3164V23.3399H23.3398Z"
        fill="#66B28A"
      />
      <path
        d="M34.9179 28.3164H34.9184M23.3398 23.3399V35.6797H28.3164C28.5184 35.6797 28.7122 35.5994 28.855 35.4566L35.4565 28.855C35.5273 28.7843 35.5834 28.7003 35.6217 28.6079C35.6599 28.5155 35.6797 28.4165 35.6797 28.3164V23.3399H23.3398Z"
        stroke="#E1F3EA"
      />
      <path
        d="M11 23.3399V33.3945C11 34.6546 12.0251 35.6797 13.2851 35.6797H23.3398V23.3399H11Z"
        fill="#66B28A"
        stroke="#E1F3EA"
        strokeWidth="0.999997"
      />
      <path
        d="M18.9473 16.4082H17.9316V15.3926C17.9316 14.9719 17.5906 14.6309 17.1699 14.6309C16.7492 14.6309 16.4082 14.9719 16.4082 15.3926V16.4082H15.3926C14.9719 16.4082 14.6309 16.7493 14.6309 17.1699C14.6309 17.5906 14.9719 17.9316 15.3926 17.9316H16.4082V18.9473C16.4082 19.3679 16.7492 19.709 17.1699 19.709C17.5906 19.709 17.9316 19.3679 17.9316 18.9473V17.9316H18.9473C19.3679 17.9316 19.709 17.5906 19.709 17.1699C19.709 16.7493 19.3679 16.4082 18.9473 16.4082Z"
        fill="#E1F3EA"
      />
      <path
        d="M31.2871 17.9316H27.7324C27.3117 17.9316 26.9707 17.5906 26.9707 17.1699C26.9707 16.7493 27.3117 16.4082 27.7324 16.4082H31.2871C31.7078 16.4082 32.0488 16.7493 32.0488 17.1699C32.0488 17.5906 31.7078 17.9316 31.2871 17.9316Z"
        fill="#E1F3EA"
      />
      <path
        d="M18.2471 29.5098L18.9781 28.7788C19.2756 28.4814 19.2756 27.9991 18.9781 27.7017C18.6806 27.4041 18.1983 27.4041 17.9009 27.7017L17.1699 28.4326L16.439 27.7017C16.1416 27.4041 15.6592 27.4041 15.3618 27.7017C15.0643 27.9991 15.0643 28.4814 15.3618 28.7788L16.0927 29.5098L15.3618 30.2407C15.0643 30.5381 15.0643 31.0205 15.3618 31.3179C15.4325 31.3887 15.5164 31.4449 15.6088 31.4832C15.7013 31.5215 15.8004 31.5412 15.9004 31.541C16.0005 31.5412 16.0996 31.5215 16.192 31.4832C16.2844 31.4449 16.3684 31.3887 16.439 31.3179L17.1699 30.587L17.9009 31.3179C17.9715 31.3887 18.0555 31.4449 18.1479 31.4832C18.2403 31.5215 18.3394 31.5412 18.4395 31.541C18.5395 31.5412 18.6386 31.5215 18.731 31.4832C18.8235 31.4449 18.9074 31.3887 18.9781 31.3179C19.2756 31.0205 19.2756 30.5381 18.9781 30.2407L18.2471 29.5098Z"
        fill="#E1F3EA"
      />
      <path
        d="M21.7578 29.1289C21.7578 33.1929 25.0649 36.5 29.1289 36.5C33.1929 36.5 36.5 33.1929 36.5 29.1289C36.5 25.065 33.1929 21.7579 29.1289 21.7579C25.0649 21.7579 21.7578 25.065 21.7578 29.1289Z"
        fill="#66B28A"
        stroke="#E1F3EA"
      />
      <path
        d="M30.9062 31.4141H27.3516C26.9309 31.4141 26.5898 31.073 26.5898 30.6523C26.5898 30.2317 26.9309 29.8906 27.3516 29.8906H30.9062C31.3269 29.8906 31.668 30.2317 31.668 30.6523C31.668 31.073 31.3269 31.4141 30.9062 31.4141Z"
        fill="#E1F3EA"
      />
      <path
        d="M30.9062 28.3672H27.3516C26.9309 28.3672 26.5898 28.0261 26.5898 27.6055C26.5898 27.1848 26.9309 26.8438 27.3516 26.8438H30.9062C31.3269 26.8438 31.668 27.1848 31.668 27.6055C31.668 28.0261 31.3269 28.3672 30.9062 28.3672Z"
        fill="#E1F3EA"
      />
    </g>
    <defs>
      <clipPath id="clip0_5765_3828">
        <rect width="26" height="26" fill="white" transform="translate(11 11)" />
      </clipPath>
    </defs>
  </svg>
);

export const Circle = () => (
  <svg
    width="121"
    height="121"
    viewBox="0 0 121 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4_53)">
      <g opacity="0.2">
        <g filter="url(#filter0_d_4_53)">
          <path
            d="M87.3469 11.016C97.2285 16.3259 105.314 24.4467 110.58 34.3516C115.846 44.2565 118.057 55.5006 116.933 66.662C115.809 77.8234 111.401 88.4009 104.265 97.0568C97.1294 105.713 87.5873 112.058 76.8453 115.291C66.1034 118.524 54.644 118.499 43.9163 115.219C33.1886 111.939 23.6745 105.552 16.577 96.8644C9.47943 88.1773 5.11732 77.5806 4.04224 66.4143C2.96716 55.2481 5.22739 44.0138 10.5371 34.1321C17.672 20.8959 29.7647 11.0294 44.1635 6.69606C58.5623 2.36272 74.0919 3.91627 87.3469 11.016ZM41.0644 97.1529C48.2189 100.997 56.3526 102.633 64.4369 101.854C72.5213 101.076 80.1931 97.917 86.4824 92.7782C92.7717 87.6393 97.3958 80.7509 99.7702 72.9839C102.145 65.217 102.162 56.9204 99.8215 49.1433C97.4806 41.3662 92.8861 34.4579 86.619 29.292C80.352 24.1261 72.6937 20.9347 64.6128 20.1212C56.5319 19.3077 48.3913 20.9087 41.2203 24.7218C34.0493 28.535 28.1701 34.3889 24.3261 41.5433C21.7737 46.2938 20.182 51.5004 19.6419 56.866C19.1018 62.2315 19.6237 67.6509 21.178 72.8148C22.7323 77.9786 25.2885 82.7857 28.7006 86.9617C32.1127 91.1376 36.314 94.6006 41.0644 97.1529Z"
            fill="white"
          />
        </g>
      </g>
      <g opacity="0.2">
        <path
          d="M87.3469 11.016C94.0583 14.456 100.016 19.1998 104.872 24.9701C109.728 30.7403 113.385 37.4211 115.628 44.6214C117.871 51.8218 118.656 59.3972 117.936 66.9045C117.216 74.4117 115.006 81.7001 111.436 88.343C107.866 94.986 103.006 100.85 97.1422 105.593C91.2782 110.335 84.5273 113.86 77.2844 115.962C70.0416 118.064 62.4523 118.701 54.9606 117.834C47.4688 116.968 40.2251 114.616 33.6531 110.917L41.0644 97.1277C48.9282 101.34 57.9512 102.874 66.7654 101.497C75.5796 100.119 83.7042 95.905 89.9075 89.4936C96.1108 83.0821 100.055 74.8229 101.141 65.9681C102.227 57.1133 100.396 48.1458 95.9264 40.4251C91.4566 32.7045 84.5913 26.6518 76.3714 23.1847C68.1515 19.7176 59.0253 19.0252 50.3764 21.2124C41.7275 23.3997 34.0275 28.3473 28.444 35.3051C22.8605 42.263 19.6979 50.8516 19.4356 59.769L3.80646 59.3152C4.09008 49.651 6.83945 40.2196 11.7935 31.9169C16.7475 23.6141 23.7417 16.7155 32.1119 11.8763C40.482 7.03704 49.9503 4.41777 59.6175 4.26721C69.2848 4.11665 78.8301 6.4398 87.3469 11.016Z"
          fill="white"
        />
      </g>
      <g opacity="0.2">
        <path
          d="M87.3469 11.016C94.0583 14.456 100.016 19.1998 104.872 24.9701C109.728 30.7403 113.385 37.421 115.628 44.6214C117.871 51.8218 118.656 59.3972 117.936 66.9045C117.216 74.4117 115.006 81.7001 111.436 88.343C107.866 94.986 103.006 100.85 97.1422 105.593C91.2782 110.335 84.5273 113.86 77.2844 115.962C70.0416 118.064 62.4523 118.701 54.9606 117.834C47.4688 116.968 40.2251 114.616 33.6531 110.917L41.0644 97.1277C47.6648 100.672 55.1089 102.342 62.5907 101.959C70.0725 101.576 77.3069 99.153 83.5106 94.9532C89.7143 90.7534 94.6509 84.9364 97.7859 78.1323C100.921 71.3281 102.135 63.796 101.296 56.3514C100.457 48.9069 97.5981 41.8336 93.0279 35.8975C88.4577 29.9614 82.3507 25.3885 75.3681 22.6742C68.3854 19.9599 60.7933 19.2074 53.4138 20.4983C46.0342 21.7893 39.1484 25.0743 33.5019 29.9979L23.1917 18.2508C31.9013 10.7025 42.6939 5.9707 54.1467 4.67916C65.5995 3.38762 77.1749 5.597 87.3469 11.016Z"
          fill="white"
        />
      </g>
      <g opacity="0.4">
        <path
          d="M113.79 41.5685C117.715 52.3659 118.269 64.1007 115.378 75.2195C112.486 86.3384 106.287 96.3171 97.5993 103.835C88.9118 111.353 78.1463 116.055 66.7274 117.32C55.3086 118.584 43.775 116.351 33.6531 110.917L41.0644 97.1277C48.3945 101.054 56.7439 102.663 65.0082 101.741C73.2724 100.819 81.062 97.4094 87.3464 91.9638C93.6308 86.5182 98.1139 79.293 100.203 71.2441C102.291 63.1951 101.887 54.7017 99.0436 46.8875L113.79 41.5685Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_4_53"
        x="-0.218872"
        y="4.28647"
        width="117.438"
        height="117.411"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4_53"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4_53"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_4_53">
        <rect width="121" height="121" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SellerAccountStatic = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#E1F3EA" />
      <g clip-path="url(#clip0_5765_3842)">
        <path
          d="M35.4469 38.5H12.5531C10.4835 38.5 9.0183 36.4749 9.64712 34.4929L11.906 27.4113C12.7485 24.7603 15.6117 23.3489 18.2186 24.294C19.7509 24.8524 21.6801 25.2758 24 25.2758C26.3199 25.2758 28.2491 24.8524 29.7814 24.294C32.3822 23.3489 35.2515 24.7603 36.094 27.4113L38.3529 34.4929C38.9817 36.4749 37.5165 38.5 35.4469 38.5Z"
          fill="#66B28A"
        />
        <path
          d="M24 23.6602C27.9102 23.6602 31.0801 20.4903 31.0801 16.5801C31.0801 12.6699 27.9102 9.5 24 9.5C20.0898 9.5 16.9199 12.6699 16.9199 16.5801C16.9199 20.4903 20.0898 23.6602 24 23.6602Z"
          fill="#66B28A"
        />
        <path
          d="M21.7418 34.7187L21.7418 34.7187L21.7436 34.7122L23.4354 28.5672L23.4354 28.5672L23.4362 28.5641C23.5087 28.2934 23.4838 28.0018 23.3491 27.746C23.349 27.746 23.349 27.7459 23.3489 27.7458L22.163 25.4875C22.7445 25.5569 23.3573 25.595 24.0012 25.595C24.6452 25.595 25.258 25.5569 25.8395 25.4875L24.6535 27.7458C24.6535 27.7459 24.6534 27.746 24.6534 27.7461C24.5192 28.0009 24.4929 28.2998 24.5673 28.5678C24.5673 28.5679 24.5674 28.5681 24.5674 28.5683L26.258 34.7089C26.2751 34.7765 26.2625 34.8459 26.2301 34.897L24.0631 38.0111C24.0362 38.0432 24.0126 38.0469 24.0012 38.0469C23.9899 38.0469 23.9663 38.0432 23.9394 38.0111L21.7699 34.8935C21.7697 34.8933 21.7696 34.893 21.7694 34.8927C21.7376 34.8459 21.7252 34.7757 21.7418 34.7187Z"
          fill="#E1F3EA"
          stroke="#E1F3EA"
          stroke-width="0.90625"
        />
      </g>
      <defs>
        <clipPath id="clip0_5765_3842">
          <rect width="29" height="29" fill="white" transform="translate(9.5 9.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SellerAccount = (props: IconProps) => {
  return (
    <>
      {props.isActive ? (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="48" height="48" rx="8" fill="#E1F3EA" />
          <g clip-path="url(#clip0_5937_115972)">
            <path
              d="M35.4469 38.5H12.5531C10.4835 38.5 9.0183 36.4749 9.64712 34.4929L11.906 27.4113C12.7485 24.7603 15.6117 23.3489 18.2186 24.294C19.7509 24.8524 21.6801 25.2758 24 25.2758C26.3199 25.2758 28.2491 24.8524 29.7814 24.294C32.3822 23.3489 35.2515 24.7603 36.094 27.4113L38.3529 34.4929C38.9817 36.4749 37.5165 38.5 35.4469 38.5Z"
              fill="#66B28A"
            />
            <path
              d="M24 23.6602C27.9102 23.6602 31.0801 20.4903 31.0801 16.5801C31.0801 12.6699 27.9102 9.5 24 9.5C20.0898 9.5 16.9199 12.6699 16.9199 16.5801C16.9199 20.4903 20.0898 23.6602 24 23.6602Z"
              fill="#66B28A"
            />
            <path
              d="M21.7418 34.7187L21.7418 34.7187L21.7436 34.7122L23.4354 28.5672L23.4354 28.5672L23.4362 28.5641C23.5087 28.2934 23.4838 28.0018 23.3491 27.746C23.349 27.746 23.349 27.7459 23.3489 27.7458L22.163 25.4875C22.7445 25.5569 23.3573 25.595 24.0012 25.595C24.6452 25.595 25.258 25.5569 25.8395 25.4875L24.6535 27.7458C24.6535 27.7459 24.6534 27.746 24.6534 27.7461C24.5192 28.0009 24.4929 28.2998 24.5673 28.5678C24.5673 28.5679 24.5674 28.5681 24.5674 28.5683L26.258 34.7089C26.2751 34.7765 26.2625 34.8459 26.2301 34.897L24.0631 38.0111C24.0362 38.0432 24.0126 38.0469 24.0012 38.0469C23.9899 38.0469 23.9663 38.0432 23.9394 38.0111L21.7699 34.8935C21.7697 34.8933 21.7696 34.893 21.7694 34.8927C21.7376 34.8459 21.7252 34.7757 21.7418 34.7187Z"
              fill="#E1F3EA"
              stroke="#E1F3EA"
              stroke-width="0.90625"
            />
          </g>
          <defs>
            <clipPath id="clip0_5937_115972">
              <rect
                width="29"
                height="29"
                fill="white"
                transform="translate(9.5 9.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="48" height="48" rx="8" fill="#EEF2FD" />
          <g clip-path="url(#clip0_6778_6353)">
            <path
              d="M35.4469 38.5H12.5531C10.4835 38.5 9.0183 36.4749 9.64712 34.4929L11.906 27.4113C12.7485 24.7603 15.6117 23.3489 18.2186 24.294C19.7509 24.8524 21.6801 25.2758 24 25.2758C26.3199 25.2758 28.2491 24.8524 29.7814 24.294C32.3822 23.3489 35.2515 24.7603 36.094 27.4113L38.3529 34.4929C38.9817 36.4749 37.5165 38.5 35.4469 38.5Z"
              fill="#C9D5F2"
            />
            <path
              d="M24 23.6602C27.9102 23.6602 31.0801 20.4903 31.0801 16.5801C31.0801 12.6699 27.9102 9.5 24 9.5C20.0898 9.5 16.9199 12.6699 16.9199 16.5801C16.9199 20.4903 20.0898 23.6602 24 23.6602Z"
              fill="#C9D5F2"
            />
            <path
              d="M21.7418 34.7187L21.7418 34.7187L21.7436 34.7122L23.4354 28.5672L23.4354 28.5672L23.4362 28.5641C23.5087 28.2934 23.4838 28.0018 23.3491 27.746C23.349 27.746 23.349 27.7459 23.3489 27.7458L22.163 25.4875C22.7445 25.5569 23.3573 25.595 24.0012 25.595C24.6452 25.595 25.258 25.5569 25.8395 25.4875L24.6535 27.7458C24.6535 27.7459 24.6534 27.746 24.6534 27.7461C24.5192 28.0009 24.4929 28.2998 24.5673 28.5678C24.5673 28.5679 24.5674 28.5681 24.5674 28.5683L26.258 34.7089C26.2751 34.7765 26.2625 34.8459 26.2301 34.897L24.0631 38.0111C24.0362 38.0432 24.0126 38.0469 24.0012 38.0469C23.9899 38.0469 23.9663 38.0432 23.9394 38.0111L21.7699 34.8935C21.7697 34.8933 21.7696 34.893 21.7694 34.8927C21.7376 34.8459 21.7252 34.7757 21.7418 34.7187Z"
              fill="#EEF2FD"
              stroke="#EEF2FD"
              stroke-width="0.90625"
            />
          </g>
          <defs>
            <clipPath id="clip0_6778_6353">
              <rect
                width="29"
                height="29"
                fill="white"
                transform="translate(9.5 9.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
};

export const Logistics = (props: IconProps) => {
  return props.isActive ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#E1F3EA" />
      <path
        d="M40.7667 23.3245L38.0732 17.2305C37.9789 17.0143 37.8239 16.8302 37.627 16.7004C37.4301 16.5706 37.1999 16.5007 36.9641 16.4992H30.4435L30.8335 12.9768C30.8527 12.8059 30.8355 12.6327 30.7829 12.4689C30.7304 12.305 30.6438 12.1542 30.5288 12.0262C30.4148 11.8999 30.2757 11.7989 30.1204 11.7296C29.9651 11.6604 29.797 11.6244 29.6269 11.624H12.844C12.5208 11.624 12.2107 11.7524 11.9822 11.981C11.7536 12.2095 11.6252 12.5195 11.6252 12.8428C11.6252 13.166 11.7536 13.476 11.9822 13.7046C12.2107 13.9332 12.5208 14.0616 12.844 14.0616H18.938C19.2612 14.0616 19.5713 14.19 19.7998 14.4186C20.0284 14.6471 20.1568 14.9571 20.1568 15.2804C20.1568 15.6036 20.0284 15.9136 19.7998 16.1422C19.5713 16.3708 19.2612 16.4992 18.938 16.4992H10.4064C10.0832 16.4992 9.77314 16.6276 9.54457 16.8562C9.31601 17.0847 9.1876 17.3947 9.1876 17.718C9.1876 18.0412 9.31601 18.3512 9.54457 18.5798C9.77314 18.8084 10.0832 18.9368 10.4064 18.9368H22.5944C22.9176 18.9368 23.2277 19.0652 23.4562 19.2938C23.6848 19.5223 23.8132 19.8323 23.8132 20.1556C23.8132 20.4788 23.6848 20.7888 23.4562 21.0174C23.2277 21.246 22.9176 21.3744 22.5944 21.3744H14.0628C13.7396 21.3744 13.4295 21.5028 13.201 21.7314C12.9724 21.9599 12.844 22.2699 12.844 22.5932C12.844 22.9164 12.9724 23.2264 13.201 23.455C13.4295 23.6836 13.7396 23.812 14.0628 23.812H18.938C19.2612 23.812 19.5713 23.9404 19.7998 24.169C20.0284 24.3975 20.1568 24.7075 20.1568 25.0308C20.1568 25.354 20.0284 25.664 19.7998 25.8926C19.5713 26.1212 19.2612 26.2496 18.938 26.2496H9.1876C8.86435 26.2496 8.55434 26.378 8.32577 26.6066C8.0972 26.8351 7.9688 27.1451 7.9688 27.4684C7.9688 27.7916 8.0972 28.1016 8.32577 28.3302C8.55434 28.5588 8.86435 28.6872 9.1876 28.6872H11.6252C11.9484 28.6872 12.2585 28.8156 12.487 29.0442C12.7156 29.2727 12.844 29.5827 12.844 29.906C12.844 30.2292 12.7156 30.5392 12.487 30.7678C12.2585 30.9964 11.9484 31.1248 11.6252 31.1248H10.4064C10.0832 31.1248 9.77314 31.2532 9.54457 31.4818C9.31601 31.7103 9.1876 32.0203 9.1876 32.3436C9.1876 32.6668 9.31601 32.9768 9.54457 33.2054C9.77314 33.434 10.0832 33.5624 10.4064 33.5624H13.88C14.0116 34.0764 14.2621 34.5523 14.6113 34.9518C14.9072 35.2827 15.2698 35.5471 15.6752 35.7278C16.0806 35.9084 16.5197 36.0012 16.9635 36C17.7146 35.9785 18.4426 35.7357 19.0563 35.3021C19.6699 34.8684 20.1418 34.2632 20.4127 33.5624H29.7244C29.856 34.0764 30.1065 34.5523 30.4557 34.9518C30.7516 35.2827 31.1142 35.5471 31.5196 35.7278C31.925 35.9084 32.3641 36.0012 32.8079 36C33.559 35.9785 34.2871 35.7357 34.9007 35.3021C35.5143 34.8684 35.9862 34.2632 36.2572 33.5624H38.6948C38.9961 33.5642 39.2874 33.4544 39.5124 33.2541C39.7375 33.0537 39.8804 32.7771 39.9136 32.4777L40.852 23.9461C40.8854 23.735 40.8558 23.5187 40.7667 23.3245ZM16.9635 33.5624C16.8625 33.5668 16.7617 33.5482 16.6689 33.5081C16.576 33.468 16.4934 33.4074 16.4273 33.3308C16.3316 33.2125 16.2616 33.0755 16.2217 32.9286C16.1819 32.7817 16.173 32.6281 16.1957 32.4777C16.2268 32.1355 16.3746 31.8143 16.6142 31.568C16.8538 31.3218 17.1708 31.1653 17.512 31.1248C17.6131 31.1204 17.7138 31.139 17.8067 31.1791C17.8996 31.2192 17.9822 31.2798 18.0483 31.3564C18.144 31.4747 18.2139 31.6117 18.2538 31.7586C18.2937 31.9055 18.3025 32.059 18.2798 32.2095C18.2487 32.5517 18.101 32.8729 17.8613 33.1191C17.6217 33.3654 17.3048 33.5219 16.9635 33.5624ZM32.8079 33.5624C32.7069 33.5668 32.6061 33.5482 32.5133 33.5081C32.4204 33.468 32.3378 33.4074 32.2717 33.3308C32.176 33.2125 32.106 33.0755 32.0661 32.9286C32.0263 32.7817 32.0174 32.6281 32.0401 32.4777C32.0712 32.1355 32.219 31.8143 32.4586 31.568C32.6982 31.3218 33.0152 31.1653 33.3564 31.1248C33.4575 31.1204 33.5582 31.139 33.6511 31.1791C33.744 31.2192 33.8266 31.2798 33.8927 31.3564C33.9884 31.4747 34.0584 31.6117 34.0982 31.7586C34.1381 31.9055 34.147 32.059 34.1243 32.2095C34.0931 32.5517 33.9454 32.8729 33.7058 33.1191C33.4661 33.3654 33.1492 33.5219 32.8079 33.5624ZM38.2926 25.0308H32.9055C32.7354 25.0304 32.5673 24.9944 32.4119 24.9251C32.2566 24.8559 32.1175 24.7548 32.0035 24.6286C31.8885 24.5006 31.8019 24.3497 31.7494 24.1859C31.6969 24.022 31.6796 23.8489 31.6988 23.6779L32.101 20.0215C32.137 19.7242 32.2811 19.4506 32.5059 19.2528C32.7307 19.0549 33.0204 18.9468 33.3198 18.949H36.1597L38.4388 24.007L38.2926 25.0308Z"
        fill="#66B28A"
      />
      <path
        d="M9.1876 23.8116C9.51085 23.8116 9.82085 23.6832 10.0494 23.4546C10.278 23.226 10.4064 22.916 10.4064 22.5928C10.4064 22.2695 10.278 21.9595 10.0494 21.731C9.82085 21.5024 9.51085 21.374 9.1876 21.374H7.9688C7.64555 21.374 7.33555 21.5024 7.10698 21.731C6.87841 21.9595 6.75 22.2695 6.75 22.5928C6.75 22.916 6.87841 23.226 7.10698 23.4546C7.33555 23.6832 7.64555 23.8116 7.9688 23.8116H9.1876Z"
        fill="#66B28A"
      />
    </svg>
  ) : (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.945312" width="48" height="48" rx="8" fill="#EEF2FD" />
      <path
        d="M40.7667 24.2698L38.0731 18.1758C37.9788 17.9597 37.8238 17.7756 37.627 17.6458C37.4301 17.516 37.1998 17.4461 36.964 17.4445H30.4434L30.8334 13.9222C30.8526 13.7512 30.8354 13.5781 30.7829 13.4142C30.7304 13.2504 30.6438 13.0995 30.5287 12.9715C30.4148 12.8453 30.2757 12.7443 30.1204 12.675C29.965 12.6057 29.7969 12.5697 29.6268 12.5693H12.844C12.5207 12.5693 12.2107 12.6977 11.9821 12.9263C11.7536 13.1549 11.6252 13.4649 11.6252 13.7881C11.6252 14.1114 11.7536 14.4214 11.9821 14.65C12.2107 14.8785 12.5207 15.0069 12.844 15.0069H18.938C19.2612 15.0069 19.5712 15.1353 19.7998 15.3639C20.0283 15.5925 20.1568 15.9025 20.1568 16.2257C20.1568 16.549 20.0283 16.859 19.7998 17.0876C19.5712 17.3161 19.2612 17.4445 18.938 17.4445H10.4064C10.0831 17.4445 9.7731 17.5729 9.54453 17.8015C9.31596 18.0301 9.18755 18.3401 9.18755 18.6633C9.18755 18.9866 9.31596 19.2966 9.54453 19.5252C9.7731 19.7537 10.0831 19.8821 10.4064 19.8821H22.5944C22.9176 19.8821 23.2276 20.0105 23.4562 20.2391C23.6847 20.4677 23.8132 20.7777 23.8132 21.1009C23.8132 21.4242 23.6847 21.7342 23.4562 21.9628C23.2276 22.1913 22.9176 22.3197 22.5944 22.3197H14.0628C13.7395 22.3197 13.4295 22.4482 13.2009 22.6767C12.9724 22.9053 12.844 23.2153 12.844 23.5385C12.844 23.8618 12.9724 24.1718 13.2009 24.4004C13.4295 24.6289 13.7395 24.7573 14.0628 24.7573H18.938C19.2612 24.7573 19.5712 24.8858 19.7998 25.1143C20.0283 25.3429 20.1568 25.6529 20.1568 25.9761C20.1568 26.2994 20.0283 26.6094 19.7998 26.838C19.5712 27.0665 19.2612 27.1949 18.938 27.1949H9.18755C8.8643 27.1949 8.5543 27.3234 8.32573 27.5519C8.09716 27.7805 7.96875 28.0905 7.96875 28.4137C7.96875 28.737 8.09716 29.047 8.32573 29.2756C8.5543 29.5041 8.8643 29.6325 9.18755 29.6325H11.6252C11.9484 29.6325 12.2584 29.761 12.487 29.9895C12.7155 30.2181 12.844 30.5281 12.844 30.8513C12.844 31.1746 12.7155 31.4846 12.487 31.7132C12.2584 31.9417 11.9484 32.0701 11.6252 32.0701H10.4064C10.0831 32.0701 9.7731 32.1986 9.54453 32.4271C9.31596 32.6557 9.18755 32.9657 9.18755 33.2889C9.18755 33.6122 9.31596 33.9222 9.54453 34.1508C9.7731 34.3793 10.0831 34.5077 10.4064 34.5077H13.8799C14.0115 35.0218 14.262 35.4977 14.6112 35.8972C14.9071 36.228 15.2697 36.4925 15.6751 36.6731C16.0806 36.8538 16.5196 36.9465 16.9635 36.9453C17.7146 36.9239 18.4426 36.6811 19.0562 36.2474C19.6698 35.8138 20.1417 35.2086 20.4127 34.5077H29.7243C29.8559 35.0218 30.1064 35.4977 30.4556 35.8972C30.7515 36.228 31.1141 36.4925 31.5195 36.6731C31.925 36.8538 32.364 36.9465 32.8079 36.9453C33.559 36.9239 34.287 36.6811 34.9006 36.2474C35.5143 35.8138 35.9861 35.2086 36.2571 34.5077H38.6947C38.996 34.5096 39.2873 34.3997 39.5124 34.1994C39.7375 33.9991 39.8804 33.7225 39.9135 33.423L40.852 24.8914C40.8854 24.6803 40.8557 24.4641 40.7667 24.2698ZM16.9635 34.5077C16.8624 34.5121 16.7617 34.4935 16.6688 34.4534C16.5759 34.4133 16.4933 34.3527 16.4272 34.2762C16.3316 34.1578 16.2616 34.0208 16.2217 33.874C16.1818 33.7271 16.173 33.5735 16.1957 33.423C16.2268 33.0808 16.3745 32.7597 16.6142 32.5134C16.8538 32.2671 17.1707 32.1106 17.512 32.0701C17.613 32.0658 17.7138 32.0843 17.8066 32.1244C17.8995 32.1646 17.9821 32.2252 18.0482 32.3017C18.1439 32.4201 18.2139 32.5571 18.2538 32.7039C18.2936 32.8508 18.3025 33.0044 18.2798 33.1549C18.2487 33.4971 18.1009 33.8182 17.8613 34.0645C17.6217 34.3108 17.3047 34.4673 16.9635 34.5077ZM32.8079 34.5077C32.7068 34.5121 32.6061 34.4935 32.5132 34.4534C32.4203 34.4133 32.3378 34.3527 32.2716 34.2762C32.176 34.1578 32.106 34.0208 32.0661 33.874C32.0262 33.7271 32.0174 33.5735 32.0401 33.423C32.0712 33.0808 32.2189 32.7597 32.4586 32.5134C32.6982 32.2671 33.0151 32.1106 33.3564 32.0701C33.4574 32.0658 33.5582 32.0843 33.6511 32.1244C33.7439 32.1646 33.8265 32.2252 33.8926 32.3017C33.9883 32.4201 34.0583 32.5571 34.0982 32.7039C34.138 32.8508 34.1469 33.0044 34.1242 33.1549C34.0931 33.4971 33.9453 33.8182 33.7057 34.0645C33.4661 34.3108 33.1491 34.4673 32.8079 34.5077ZM38.2925 25.9761H32.9054C32.7353 25.9757 32.5672 25.9397 32.4119 25.8705C32.2566 25.8012 32.1174 25.7002 32.0035 25.5739C31.8885 25.446 31.8019 25.2951 31.7493 25.1312C31.6968 24.9674 31.6796 24.7943 31.6988 24.6233L32.101 20.9669C32.1369 20.6696 32.281 20.3959 32.5058 20.1981C32.7306 20.0003 33.0204 19.8922 33.3198 19.8943H36.1596L38.4388 24.9524L38.2925 25.9761Z"
        fill="#C9D5F2"
      />
      <path
        d="M9.1876 24.7569C9.51085 24.7569 9.82085 24.6285 10.0494 24.4C10.278 24.1714 10.4064 23.8614 10.4064 23.5381C10.4064 23.2149 10.278 22.9049 10.0494 22.6763C9.82085 22.4477 9.51085 22.3193 9.1876 22.3193H7.9688C7.64555 22.3193 7.33555 22.4477 7.10698 22.6763C6.87841 22.9049 6.75 23.2149 6.75 23.5381C6.75 23.8614 6.87841 24.1714 7.10698 24.4C7.33555 24.6285 7.64555 24.7569 7.9688 24.7569H9.1876Z"
        fill="#C9D5F2"
      />
    </svg>
  );
};

export const Order = (props: IconProps) => {
  return !props.isActive ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#EEF2FD" />
      <g clip-path="url(#clip0_6753_22071)">
        <rect x="9.5" y="9.5" width="29" height="29" rx="4" fill="#C9D5F2" />
        <rect x="17.2917" y="15" width="18.2083" height="4" rx="2" fill="#EEF2FD" />
        <rect x="12.5" y="15" width="2.875" height="4" rx="1.4375" fill="#EEF2FD" />
        <rect x="17.2917" y="22" width="18.2083" height="4" rx="2" fill="#EEF2FD" />
        <rect x="12.5" y="22" width="2.875" height="4" rx="1.4375" fill="#EEF2FD" />
        <rect x="17.2917" y="29" width="18.2083" height="4" rx="2" fill="#EEF2FD" />
        <rect x="12.5" y="29" width="2.875" height="4" rx="1.4375" fill="#EEF2FD" />
      </g>
      <defs>
        <clipPath id="clip0_6753_22071">
          <rect width="29" height="29" fill="white" transform="translate(9.5 9.5)" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#E1F3EA" />
      <g clip-path="url(#clip0_6753_22070)">
        <rect x="9.5" y="9.5" width="29" height="29" rx="4" fill="#66B28A" />
        <rect x="17.2917" y="15" width="18.2083" height="4" rx="2" fill="#E1F3EA" />
        <rect x="12.5" y="15" width="2.875" height="4" rx="1.4375" fill="#E1F3EA" />
        <rect x="17.2917" y="22" width="18.2083" height="4" rx="2" fill="#E1F3EA" />
        <rect x="12.5" y="22" width="2.875" height="4" rx="1.4375" fill="#E1F3EA" />
        <rect x="17.2917" y="29" width="18.2083" height="4" rx="2" fill="#E1F3EA" />
        <rect x="12.5" y="29" width="2.875" height="4" rx="1.4375" fill="#E1F3EA" />
      </g>
      <defs>
        <clipPath id="clip0_6753_22070">
          <rect width="29" height="29" fill="white" transform="translate(9.5 9.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SimpleMix = (props: IconProps) => {
  return props.isActive ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#E1F3EA" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 10H16.778V16.435L26.8894 22.645V34H21.1115V26.065L11 19.855V10Z"
        fill="#66B28A"
      />
      <path d="M32.6669 29.5L24 37L15.333 29.5H32.6669Z" fill="#66B28A" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.2224 10V16.435L25.2422 20.11L28.1601 21.895V25.285L37.0004 19.855V10H31.2224Z"
        fill="#66B28A"
      />
    </svg>
  ) : (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#EEF2FD" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 10H16.778V16.435L26.8894 22.645V34H21.1115V26.065L11 19.855V10Z"
        fill="#C9D5F2"
      />
      <path d="M32.6669 29.5L24 37L15.333 29.5H32.6669Z" fill="#C9D5F2" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.2224 10V16.435L25.2422 20.11L28.1601 21.895V25.285L37.0004 19.855V10H31.2224Z"
        fill="#C9D5F2"
      />
    </svg>
  );
};

export const MegaMix = (props: IconProps) => {
  return props.isActive ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#E1F3EA" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35 20H30.1109V25.2433L21.5551 30.3033V39.5556H26.4441V33.09L35 28.03V20Z"
        fill="#66B28A"
      />
      <path
        d="M16.6649 35.8887L23.9984 41.9998L31.332 35.8887H16.6649Z"
        fill="#66B28A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.889 20V25.2433L22.9492 28.2378L20.4802 29.6922V32.4544L13 28.03V20H17.889Z"
        fill="#66B28A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.41026 8.82949C7.16183 8.933 7 9.17574 7 9.44488V18.3338H9V11.0004C9 10.6322 9.29848 10.3338 9.66667 10.3338H20.3333C20.7015 10.3338 21 10.6322 21 11.0004V18.3338H23V9.44488C23 9.17574 22.8382 8.933 22.5897 8.82949L15.2564 5.77394C15.0923 5.70556 14.9077 5.70556 14.7436 5.77394L7.41026 8.82949Z"
        fill="#66B28A"
      />
      <path
        d="M18.9987 15.667H10.9987C10.6305 15.667 10.332 15.9655 10.332 16.3337V17.667C10.332 18.0352 10.6305 18.3337 10.9987 18.3337H18.9987C19.3669 18.3337 19.6654 18.0352 19.6654 17.667V16.3337C19.6654 15.9655 19.3669 15.667 18.9987 15.667Z"
        fill="#66B28A"
      />
      <path
        d="M18.9987 11.667H10.9987C10.6305 11.667 10.332 11.9655 10.332 12.3337V13.667C10.332 14.0352 10.6305 14.3337 10.9987 14.3337H18.9987C19.3669 14.3337 19.6654 14.0352 19.6654 13.667V12.3337C19.6654 11.9655 19.3669 11.667 18.9987 11.667Z"
        fill="#66B28A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.4103 8.82949C25.1618 8.933 25 9.17574 25 9.44488V18.3338H27V11.0004C27 10.6322 27.2985 10.3338 27.6667 10.3338H38.3333C38.7015 10.3338 39 10.6322 39 11.0004V18.3338H41V9.44488C41 9.17574 40.8382 8.933 40.5897 8.82949L33.2564 5.77394C33.0923 5.70556 32.9077 5.70556 32.7436 5.77394L25.4103 8.82949Z"
        fill="#66B28A"
      />
      <path
        d="M36.9987 15.667H28.9987C28.6305 15.667 28.332 15.9655 28.332 16.3337V17.667C28.332 18.0352 28.6305 18.3337 28.9987 18.3337H36.9987C37.3669 18.3337 37.6654 18.0352 37.6654 17.667V16.3337C37.6654 15.9655 37.3669 15.667 36.9987 15.667Z"
        fill="#66B28A"
      />
      <path
        d="M36.9987 11.667H28.9987C28.6305 11.667 28.332 11.9655 28.332 12.3337V13.667C28.332 14.0352 28.6305 14.3337 28.9987 14.3337H36.9987C37.3669 14.3337 37.6654 14.0352 37.6654 13.667V12.3337C37.6654 11.9655 37.3669 11.667 36.9987 11.667Z"
        fill="#66B28A"
      />
    </svg>
  ) : (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#EEF2FD" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35 20H30.1109V25.2433L21.5551 30.3033V39.5556H26.4441V33.09L35 28.03V20Z"
        fill="#C9D5F2"
      />
      <path d="M16.6664 35.8889L24 42L31.3336 35.8889H16.6664Z" fill="#C9D5F2" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.8887 20V25.2433L22.9489 28.2378L20.4799 29.6922V32.4544L12.9997 28.03V20H17.8887Z"
        fill="#C9D5F2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.41026 8.82905C7.16183 8.93256 7 9.1753 7 9.44443V18.3333H9V11C9 10.6318 9.29848 10.3333 9.66667 10.3333H20.3333C20.7015 10.3333 21 10.6318 21 11V18.3333H23V9.44443C23 9.1753 22.8382 8.93256 22.5897 8.82905L15.2564 5.77349C15.0923 5.70512 14.9077 5.70512 14.7436 5.77349L7.41026 8.82905Z"
        fill="#C9D5F2"
      />
      <path
        d="M19 15.6667H11C10.6318 15.6667 10.3333 15.9651 10.3333 16.3333V17.6667C10.3333 18.0349 10.6318 18.3333 11 18.3333H19C19.3682 18.3333 19.6667 18.0349 19.6667 17.6667V16.3333C19.6667 15.9651 19.3682 15.6667 19 15.6667Z"
        fill="#C9D5F2"
      />
      <path
        d="M19 11.6667H11C10.6318 11.6667 10.3333 11.9651 10.3333 12.3333V13.6667C10.3333 14.0349 10.6318 14.3333 11 14.3333H19C19.3682 14.3333 19.6667 14.0349 19.6667 13.6667V12.3333C19.6667 11.9651 19.3682 11.6667 19 11.6667Z"
        fill="#C9D5F2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.4103 8.82905C25.1618 8.93256 25 9.1753 25 9.44443V18.3333H27V11C27 10.6318 27.2985 10.3333 27.6667 10.3333H38.3333C38.7015 10.3333 39 10.6318 39 11V18.3333H41V9.44443C41 9.1753 40.8382 8.93256 40.5897 8.82905L33.2564 5.77349C33.0923 5.70512 32.9077 5.70512 32.7436 5.77349L25.4103 8.82905Z"
        fill="#C9D5F2"
      />
      <path
        d="M37 15.6667H29C28.6318 15.6667 28.3333 15.9651 28.3333 16.3333V17.6667C28.3333 18.0349 28.6318 18.3333 29 18.3333H37C37.3682 18.3333 37.6667 18.0349 37.6667 17.6667V16.3333C37.6667 15.9651 37.3682 15.6667 37 15.6667Z"
        fill="#C9D5F2"
      />
      <path
        d="M37 11.6667H29C28.6318 11.6667 28.3333 11.9651 28.3333 12.3333V13.6667C28.3333 14.0349 28.6318 14.3333 29 14.3333H37C37.3682 14.3333 37.6667 14.0349 37.6667 13.6667V12.3333C37.6667 11.9651 37.3682 11.6667 37 11.6667Z"
        fill="#C9D5F2"
      />
    </svg>
  );
};

export const Trades = (props: IconProps) => {
  return props.isActive ? (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#E1F3EA" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M41.6744 17.8494H35.3548L30.4385 9.63412C30.0558 9.00862 29.2389 8.81259 28.6151 9.19635C27.9995 9.57514 27.7998 10.3776 28.1652 11.0022L32.2629 17.8494H15.7363L19.834 11.0022C20.2043 10.3693 19.993 9.5552 19.3617 9.18306C18.7396 8.81674 17.9384 9.01693 17.5606 9.63412L12.6444 17.8494H6.32557C5.59319 17.8494 5 18.4442 5 19.1785C5 19.9128 5.59319 20.5076 6.32557 20.5076H6.96682L9.48043 35.9139C9.86485 38.2705 11.8955 40.0008 14.2773 40H33.7227C36.1045 40 38.1352 38.2697 38.5196 35.9139L41.0332 20.5076H41.6744C42.4068 20.5076 43 19.9128 43 19.1785C43 18.4442 42.4068 17.8494 41.6744 17.8494Z"
        fill="#66B28A"
      />
      <path
        d="M15.743 33.0113L13.2664 35.4548C12.9223 35.7943 12.9186 36.3485 13.2581 36.6925C13.5976 37.0366 14.1517 37.0403 14.4958 36.7008L16.9724 34.2573C16.4089 34.0283 15.9643 33.5777 15.743 33.0113Z"
        fill="#E1F3EA"
      />
      <path
        d="M35.4811 14.9692L35.4602 14.7865L35.2779 14.7632C33.8084 14.5753 32.0974 15.2461 30.8125 16.5139C29.5277 17.7817 28.8339 19.4836 29.002 20.9553L29.0229 21.138L29.2052 21.1613C29.3597 21.181 29.517 21.1913 29.676 21.1924C31.0298 21.2015 32.5208 20.545 33.6706 19.4106C34.9554 18.1428 35.6492 16.4409 35.4811 14.9692Z"
        fill="#E1F3EA"
      />
      <path
        d="M29.2394 13.3161C28.9639 13.0368 28.5141 13.0337 28.2348 13.3093L26.0976 15.4181C24.9835 16.2279 24.1739 17.6848 23.9511 19.3198C23.7073 21.1083 24.1969 22.8798 25.2286 23.9428L25.3566 24.0748L25.5153 23.9819C26.7937 23.2336 27.7394 21.6577 27.9831 19.8692C28.1663 18.5246 27.935 17.1896 27.3705 16.158L29.2327 14.3206C29.5119 14.0451 29.5149 13.5953 29.2394 13.3161Z"
        fill="#E1F3EA"
      />
      <path
        d="M18.0841 23.7527L17.9561 23.6208L17.7975 23.7136C16.519 24.4619 15.5733 26.0377 15.3296 27.8263C15.0859 29.6148 15.5754 31.3862 16.6071 32.4493L16.7351 32.5812L16.8938 32.4883C18.1723 31.74 19.1179 30.1642 19.3616 28.3757C19.6053 26.5872 19.1159 24.8157 18.0841 23.7527Z"
        fill="#E1F3EA"
      />
      <path
        d="M22.3952 19.4992L22.2672 19.3672L22.1085 19.4601C20.83 20.2084 19.8844 21.7842 19.6406 23.5728C19.3969 25.3613 19.8864 27.1327 20.9181 28.1958L21.0462 28.3277L21.2048 28.2348C22.4833 27.4865 23.429 25.9106 23.6726 24.1222C23.9164 22.3337 23.4269 20.5622 22.3952 19.4992Z"
        fill="#E1F3EA"
      />
      <path
        d="M26.2616 32.0406C25.2125 30.9948 23.4477 30.4816 21.6562 30.7012C19.8646 30.9209 18.2761 31.8453 17.5108 33.1136L17.4158 33.271L17.546 33.4008C18.4256 34.2778 19.8085 34.7802 21.2884 34.7902C21.5734 34.7921 21.8621 34.7757 22.1514 34.7402C23.943 34.5205 25.5315 33.5962 26.2968 32.3278L26.3918 32.1704L26.2616 32.0406Z"
        fill="#E1F3EA"
      />
      <path
        d="M30.5727 27.7871C29.5235 26.7413 27.7586 26.2279 25.9672 26.4477C24.1756 26.6674 22.5872 27.5918 21.8218 28.8601L21.7268 29.0175L21.857 29.1473C22.7367 30.0242 24.1195 30.5267 25.5994 30.5367C25.8844 30.5386 26.1731 30.5222 26.4624 30.4867C28.2541 30.2671 29.8425 29.3427 30.6079 28.0743L30.7029 27.9169L30.5727 27.7871Z"
        fill="#E1F3EA"
      />
      <path
        d="M36.8471 21.0266C36.5715 20.7473 36.1218 20.7443 35.8425 21.0199L33.9803 22.8572C32.9563 22.2788 31.6245 22.0296 30.2776 22.1948C28.486 22.4144 26.8975 23.3388 26.1322 24.6072L26.0372 24.7646L26.1674 24.8944C27.0471 25.7713 28.4299 26.2738 29.9098 26.2837C30.1948 26.2856 30.4835 26.2693 30.7728 26.2338C32.4107 26.033 33.8784 25.243 34.7031 24.1399L36.8403 22.0312C37.1196 21.7556 37.1226 21.3059 36.8471 21.0266Z"
        fill="#E1F3EA"
      />
    </svg>
  ) : (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.945312" width="48" height="48" rx="8" fill="#EEF2FD" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M41.6744 18.7947H35.3548L30.4385 10.5794C30.0558 9.95394 29.2389 9.7579 28.6151 10.1417C27.9995 10.5205 27.7998 11.3229 28.1652 11.9475L32.2629 18.7947H15.7363L19.834 11.9475C20.2043 11.3146 19.993 10.5005 19.3617 10.1284C18.7396 9.76205 17.9384 9.96224 17.5606 10.5794L12.6444 18.7947H6.32557C5.59319 18.7947 5 19.3895 5 20.1238C5 20.8581 5.59319 21.4529 6.32557 21.4529H6.96682L9.48043 36.8593C9.86485 39.2159 11.8955 40.9461 14.2773 40.9453H33.7227C36.1045 40.9453 38.1352 39.215 38.5196 36.8593L41.0332 21.4529H41.6744C42.4068 21.4529 43 20.8581 43 20.1238C43 19.3895 42.4068 18.7947 41.6744 18.7947Z"
        fill="#C9D5F2"
      />
      <path
        d="M15.7423 33.9566L13.2657 36.4001C12.9216 36.7396 12.9179 37.2938 13.2574 37.6378C13.5969 37.9819 14.1511 37.9856 14.4951 37.6461L16.9717 35.2026C16.4082 34.9736 15.9637 34.523 15.7423 33.9566Z"
        fill="#EEF2FD"
      />
      <path
        d="M35.4804 15.9145L35.4596 15.7318L35.2772 15.7085C33.8078 15.5206 32.0968 16.1914 30.8118 17.4592C29.5271 18.727 28.8333 20.4289 29.0014 21.9007L29.0222 22.0833L29.2046 22.1066C29.3591 22.1264 29.5163 22.1366 29.6754 22.1377C31.0292 22.1468 32.5202 21.4903 33.6699 20.3559C34.9548 19.0881 35.6486 17.3863 35.4804 15.9145Z"
        fill="#EEF2FD"
      />
      <path
        d="M29.2387 14.2614C28.9632 13.9821 28.5134 13.979 28.2342 14.2546L26.0969 16.3634C24.9828 17.1732 24.1732 18.6301 23.9504 20.2651C23.7067 22.0536 24.1962 23.8251 25.2279 24.8881L25.3559 25.0201L25.5146 24.9272C26.7931 24.1789 27.7387 22.603 27.9824 20.8146C28.1656 19.4699 27.9343 18.1349 27.3698 17.1033L29.232 15.2659C29.5113 14.9904 29.5143 14.5406 29.2387 14.2614Z"
        fill="#EEF2FD"
      />
      <path
        d="M18.0835 24.698L17.9555 24.5661L17.7968 24.6589C16.5183 25.4072 15.5727 26.9831 15.3289 28.7716C15.0852 30.5601 15.5747 32.3315 16.6064 33.3946L16.7345 33.5265L16.8931 33.4337C18.1716 32.6853 19.1173 31.1095 19.3609 29.321C19.6047 27.5325 19.1152 25.761 18.0835 24.698Z"
        fill="#EEF2FD"
      />
      <path
        d="M22.3945 20.4445L22.2665 20.3126L22.1078 20.4054C20.8293 21.1537 19.8837 22.7295 19.64 24.5181C19.3962 26.3066 19.8858 28.078 20.9175 29.1411L21.0455 29.273L21.2042 29.1801C22.4827 28.4318 23.4283 26.856 23.672 25.0675C23.9157 23.279 23.4262 21.5075 22.3945 20.4445Z"
        fill="#EEF2FD"
      />
      <path
        d="M26.261 32.9859C25.2118 31.9401 23.447 31.4269 21.6555 31.6465C19.8639 31.8662 18.2755 32.7906 17.5101 34.0589L17.4151 34.2163L17.5453 34.3461C18.425 35.2231 19.8078 35.7255 21.2877 35.7355C21.5727 35.7374 21.8614 35.721 22.1507 35.6855C23.9424 35.4658 25.5308 34.5415 26.2962 33.2731L26.3912 33.1157L26.261 32.9859Z"
        fill="#EEF2FD"
      />
      <path
        d="M30.572 28.7325C29.5229 27.6866 27.7579 27.1733 25.9666 27.393C24.175 27.6127 22.5865 28.5371 21.8211 29.8054L21.7262 29.9628L21.8563 30.0926C22.736 30.9696 24.1188 31.472 25.5987 31.482C25.8838 31.4839 26.1725 31.4675 26.4618 31.4321C28.2534 31.2124 29.8419 30.288 30.6072 29.0197L30.7022 28.8622L30.572 28.7325Z"
        fill="#EEF2FD"
      />
      <path
        d="M36.8464 21.9719C36.5709 21.6926 36.1211 21.6896 35.8419 21.9652L33.9797 23.8025C32.9557 23.2242 31.6238 22.9749 30.277 23.1401C28.4853 23.3598 26.8969 24.2841 26.1315 25.5525L26.0365 25.7099L26.1667 25.8397C27.0464 26.7166 28.4292 27.2191 29.9091 27.229C30.1942 27.231 30.4829 27.2146 30.7722 27.1791C32.4101 26.9783 33.8778 26.1883 34.7024 25.0852L36.8396 22.9765C37.1189 22.7009 37.122 22.2512 36.8464 21.9719Z"
        fill="#EEF2FD"
      />
    </svg>
  );
};
